module.exports = {
  "2013-09-30": "123.65499",
  "2013-10-01": "125.455",
  "2013-10-02": "108.58483",
  "2013-10-03": "118.67466",
  "2013-10-04": "121.33866",
  "2013-10-05": "120.65533",
  "2013-10-06": "121.795",
  "2013-10-07": "123.033",
  "2013-10-08": "124.049",
  "2013-10-09": "125.96116",
  "2013-10-10": "125.27966",
  "2013-10-11": "125.9275",
  "2013-10-12": "126.38333",
  "2013-10-13": "135.24199",
  "2013-10-14": "133.20333",
  "2013-10-15": "142.76333",
  "2013-10-16": "137.92333",
  "2013-10-17": "142.95166",
  "2013-10-18": "152.55183",
  "2013-10-19": "160.33883",
  "2013-10-20": "164.31499",
  "2013-10-21": "177.63333",
  "2013-10-22": "188.29716",
  "2013-10-23": "200.70166",
  "2013-10-24": "180.355",
  "2013-10-25": "175.03166",
  "2013-10-26": "177.6965",
  "2013-10-27": "187.15983",
  "2013-10-28": "192.75666",
  "2013-10-29": "197.4",
  "2013-10-30": "196.02499",
  "2013-10-31": "198.04883",
  "2013-11-01": "198.93233",
  "2013-11-02": "200.543",
  "2013-11-03": "210.3075",
  "2013-11-04": "225.02",
  "2013-11-05": "248.25333",
  "2013-11-06": "262.32666",
  "2013-11-07": "294.48699",
  "2013-11-08": "331.10325",
  "2013-11-09": "285.8875",
  "2013-11-10": "304.97974",
  "2013-11-11": "338.137",
  "2013-11-12": "357.48",
  "2013-11-13": "402.954",
  "2013-11-14": "409.10375",
  "2013-11-15": "420.21649",
  "2013-11-16": "437.29725",
  "2013-11-17": "510.6025",
  "2013-11-18": "693.65",
  "2013-11-19": "531.54249",
  "2013-11-20": "574.71599",
  "2013-11-21": "681.33",
  "2013-11-22": "774.18",
  "2013-11-23": "746.19374",
  "2013-11-24": "768.8475",
  "2013-11-25": "789.36475",
  "2013-11-26": "893.1815",
  "2013-11-27": "934.355",
  "2013-11-28": "1068.363",
  "2013-11-29": "1154.92593",
  "2013-11-30": "1099.51926",
  "2013-12-01": "1019.78966",
  "2013-12-02": "1028.845",
  "2013-12-03": "1071.2848",
  "2013-12-04": "1139.33083",
  "2013-12-05": "1004.61633",
  "2013-12-06": "759.43041",
  "2013-12-07": "689.81",
  "2013-12-08": "841.83966",
  "2013-12-09": "916.77599",
  "2013-12-10": "967.42866",
  "2013-12-11": "866.29003",
  "2013-12-12": "911.23204",
  "2013-12-13": "889.81946",
  "2013-12-14": "848.9975",
  "2013-12-15": "868.95316",
  "2013-12-16": "653.80483",
  "2013-12-17": "654.06266",
  "2013-12-18": "553.69166",
  "2013-12-19": "693.05883",
  "2013-12-20": "649.38965",
  "2013-12-21": "595.95883",
  "2013-12-22": "647.68316",
  "2013-12-23": "671.58116",
  "2013-12-24": "659.84333",
  "2013-12-25": "702.00083",
  "2013-12-26": "758.01016",
  "2013-12-27": "734.01166",
  "2013-12-28": "717.92623",
  "2013-12-29": "752.82022",
  "2013-12-30": "744.17249",
  "2013-12-31": "768.40783",
  "2014-01-01": "769.09849",
  "2014-01-02": "804.02719",
  "2014-01-03": "813.31748",
  "2014-01-04": "871.11583",
  "2014-01-05": "970.65083",
  "2014-01-06": "962.46447",
  "2014-01-07": "855.75933",
  "2014-01-08": "860.84166",
  "2014-01-09": "847.5325",
  "2014-01-10": "892.26115",
  "2014-01-11": "916.69666",
  "2014-01-12": "873.27168",
  "2014-01-13": "863.69888",
  "2014-01-14": "853.25666",
  "2014-01-15": "874.07416",
  "2014-01-16": "842.19173",
  "2014-01-17": "834.86666",
  "2014-01-18": "838.42916",
  "2014-01-19": "881.87583",
  "2014-01-20": "873.28916",
  "2014-01-21": "874.13266",
  "2014-01-22": "864.56116",
  "2014-01-23": "838.14997",
  "2014-01-24": "834.57416",
  "2014-01-25": "858.12641",
  "2014-01-26": "887.08337",
  "2014-01-27": "830.53133",
  "2014-01-28": "832.89496",
  "2014-01-29": "832.87399",
  "2014-01-30": "841.48914",
  "2014-01-31": "847.36383",
  "2014-02-01": "854.7225",
  "2014-02-02": "856.03366",
  "2014-02-03": "847.70697",
  "2014-02-04": "844.28836",
  "2014-02-05": "802.75333",
  "2014-02-06": "748.43559",
  "2014-02-07": "692.66914",
  "2014-02-08": "668.86463",
  "2014-02-09": "700.44843",
  "2014-02-10": "694.3125",
  "2014-02-11": "665.7975",
  "2014-02-12": "645.615",
  "2014-02-13": "578.4125",
  "2014-02-14": "641.91",
  "2014-02-15": "656.2725",
  "2014-02-16": "611.04499",
  "2014-02-17": "634.99",
  "2014-02-18": "618.79",
  "2014-02-19": "619.8425",
  "2014-02-20": "545.7625",
  "2014-02-21": "561.535",
  "2014-02-22": "622.22",
  "2014-02-23": "572.7675",
  "2014-02-24": "501.155",
  "2014-02-25": "550.6025",
  "2014-02-26": "573.1025",
  "2014-02-27": "567.2925",
  "2014-02-28": "551.73",
  "2014-03-01": "560.195",
  "2014-03-02": "567.7",
  "2014-03-03": "666.1475",
  "2014-03-04": "660.84",
  "2014-03-05": "662.0225",
  "2014-03-06": "651.285",
  "2014-03-07": "612.33",
  "2014-03-08": "611.1625",
  "2014-03-09": "637.615",
  "2014-03-10": "626",
  "2014-03-11": "633.74749",
  "2014-03-12": "631.755",
  "2014-03-13": "636.41414",
  "2014-03-14": "628.18751",
  "2014-03-15": "632.95333",
  "2014-03-16": "630.34833",
  "2014-03-17": "617.24333",
  "2014-03-18": "616.86665",
  "2014-03-19": "601.015",
  "2014-03-20": "581.33333",
  "2014-03-21": "570.36168",
  "2014-03-22": "562.95333",
  "2014-03-23": "557.16833",
  "2014-03-24": "573.34998",
  "2014-03-25": "572.49161",
  "2014-03-26": "570.54833",
  "2014-03-27": "509.70665",
  "2014-03-28": "499.24998",
  "2014-03-29": "486.80845",
  "2014-03-30": "472.4783",
  "2014-03-31": "464.88",
  "2014-04-01": "480.16581",
  "2014-04-02": "427.87498",
  "2014-04-03": "432.99716",
  "2014-04-04": "453.87148",
  "2014-04-05": "462.445",
  "2014-04-06": "456.46948",
  "2014-04-07": "452.81",
  "2014-04-08": "450.48083",
  "2014-04-09": "426.98333",
  "2014-04-10": "374.59166",
  "2014-04-11": "438.24666",
  "2014-04-12": "423.51566",
  "2014-04-13": "409.03166",
  "2014-04-14": "455.28316",
  "2014-04-15": "517.09666",
  "2014-04-16": "522.455",
  "2014-04-17": "490.8785",
  "2014-04-18": "469.38332",
  "2014-04-19": "507.80663",
  "2014-04-20": "505.09665",
  "2014-04-21": "497.65001",
  "2014-04-22": "487.84",
  "2014-04-23": "487.11333",
  "2014-04-24": "469.08816",
  "2014-04-25": "448.77834",
  "2014-04-26": "452.14829",
  "2014-04-27": "426.78166",
  "2014-04-28": "432.60498",
  "2014-04-29": "444.85668",
  "2014-04-30": "454.55666",
  "2014-05-01": "453.59833",
  "2014-05-02": "441.97833",
  "2014-05-03": "438.29035",
  "2014-05-04": "432.78748",
  "2014-05-05": "418.61831",
  "2014-05-06": "428.42593",
  "2014-05-07": "442.57666",
  "2014-05-08": "439.04",
  "2014-05-09": "449.04333",
  "2014-05-10": "449.74166",
  "2014-05-11": "434.27",
  "2014-05-12": "437",
  "2014-05-13": "438.88",
  "2014-05-14": "445.045",
  "2014-05-15": "443.18",
  "2014-05-16": "445.60666",
  "2014-05-17": "445.15666",
  "2014-05-18": "444.73833",
  "2014-05-19": "455.65333",
  "2014-05-20": "489.86999",
  "2014-05-21": "490.18666",
  "2014-05-22": "522.31",
  "2014-05-23": "512.30833",
  "2014-05-24": "533.92999",
  "2014-05-25": "579.59333",
  "2014-05-26": "581.51",
  "2014-05-27": "572.44833",
  "2014-05-28": "562.4",
  "2014-05-29": "571.845",
  "2014-05-30": "612.12666",
  "2014-05-31": "638.16333",
  "2014-06-01": "634.98333",
  "2014-06-02": "660.24666",
  "2014-06-03": "627.79833",
  "2014-06-04": "642.89166",
  "2014-06-05": "652.52666",
  "2014-06-06": "648.60166",
  "2014-06-07": "652.59166",
  "2014-06-08": "652.11",
  "2014-06-09": "644.085",
  "2014-06-10": "642.00666",
  "2014-06-11": "632.55",
  "2014-06-12": "585.48333",
  "2014-06-13": "588.52333",
  "2014-06-14": "570.28833",
  "2014-06-15": "589.06666",
  "2014-06-16": "592.25666",
  "2014-06-17": "610.41333",
  "2014-06-18": "601.88666",
  "2014-06-19": "594.09333",
  "2014-06-20": "582.04499",
  "2014-06-21": "599.57",
  "2014-06-22": "592.405",
  "2014-06-23": "584.64166",
  "2014-06-24": "575.905",
  "2014-06-25": "571.76666",
  "2014-06-26": "582.43166",
  "2014-06-27": "597.66833",
  "2014-06-28": "598.73333",
  "2014-06-29": "597.51333",
  "2014-06-30": "647.12249",
  "2014-07-01": "637.85625",
  "2014-07-02": "642.65125",
  "2014-07-03": "643.95124",
  "2014-07-04": "628.41625",
  "2014-07-05": "631.03",
  "2014-07-06": "631.29875",
  "2014-07-07": "621.24249",
  "2014-07-08": "620.72",
  "2014-07-09": "621.3075",
  "2014-07-10": "616.83124",
  "2014-07-11": "634.35749",
  "2014-07-12": "627.69",
  "2014-07-13": "621.42499",
  "2014-07-14": "618.73875",
  "2014-07-15": "619.8075",
  "2014-07-16": "614.68875",
  "2014-07-17": "623.49749",
  "2014-07-18": "623.99625",
  "2014-07-19": "623.00625",
  "2014-07-20": "617.96124",
  "2014-07-21": "622.10749",
  "2014-07-22": "618.4475",
  "2014-07-23": "617.6875",
  "2014-07-24": "602.93125",
  "2014-07-25": "597.585",
  "2014-07-26": "592.96375",
  "2014-07-27": "580.11",
  "2014-07-28": "585.44875",
  "2014-07-29": "580.5175",
  "2014-07-30": "564.57",
  "2014-07-31": "583.39",
  "2014-08-01": "593.80625",
  "2014-08-02": "581.52",
  "2014-08-03": "585.80125",
  "2014-08-04": "582.33375",
  "2014-08-05": "582.52125",
  "2014-08-06": "583.62375",
  "2014-08-07": "595.80875",
  "2014-08-08": "585.39625",
  "2014-08-09": "586.05875",
  "2014-08-10": "588.7525",
  "2014-08-11": "566.31625",
  "2014-08-12": "565.55125",
  "2014-08-13": "534.54",
  "2014-08-14": "511.4725",
  "2014-08-15": "487.56625",
  "2014-08-16": "516.62625",
  "2014-08-17": "489.4675",
  "2014-08-18": "455.91625",
  "2014-08-19": "472.91",
  "2014-08-20": "519.015",
  "2014-08-21": "508.12875",
  "2014-08-22": "507.51",
  "2014-08-23": "501.63125",
  "2014-08-24": "503.32125",
  "2014-08-25": "504.62625",
  "2014-08-26": "513.39125",
  "2014-08-27": "514.62375",
  "2014-08-28": "506.025",
  "2014-08-29": "504.70625",
  "2014-08-30": "502.055",
  "2014-08-31": "474.5425",
  "2014-09-01": "477.98375",
  "2014-09-02": "476.88375",
  "2014-09-03": "475.65",
  "2014-09-04": "485.65125",
  "2014-09-05": "480.9075",
  "2014-09-06": "481.88375",
  "2014-09-07": "473.58625",
  "2014-09-08": "468.5775",
  "2014-09-09": "474.29125",
  "2014-09-10": "479.4175",
  "2014-09-11": "473.6725",
  "2014-09-12": "471.5325",
  "2014-09-13": "475.37875",
  "2014-09-14": "475.02125",
  "2014-09-15": "471.08375",
  "2014-09-16": "464.55375",
  "2014-09-17": "449.95875",
  "2014-09-18": "425.4475",
  "2014-09-19": "410.08",
  "2014-09-20": "405.79625",
  "2014-09-21": "399.0975",
  "2014-09-22": "399.5025",
  "2014-09-23": "427.8125",
  "2014-09-24": "416.12",
  "2014-09-25": "410.15",
  "2014-09-26": "403.4975",
  "2014-09-27": "398.84",
  "2014-09-28": "377.97875",
  "2014-09-29": "376.08375",
  "2014-09-30": "387.94",
  "2014-10-01": "381.7475",
  "2014-10-02": "372.0575",
  "2014-10-03": "360.7525",
  "2014-10-04": "335.98125",
  "2014-10-05": "308.07875",
  "2014-10-06": "337.23375",
  "2014-10-07": "326.2325",
  "2014-10-08": "351.34625",
  "2014-10-09": "368.59625",
  "2014-10-10": "359.2025",
  "2014-10-11": "356.99875",
  "2014-10-12": "371.15625",
  "2014-10-13": "392.7825",
  "2014-10-14": "396.34625",
  "2014-10-15": "392.56625",
  "2014-10-16": "376.26875",
  "2014-10-17": "378.675",
  "2014-10-18": "390.95875",
  "2014-10-19": "381.72375",
  "2014-10-20": "380.0575",
  "2014-10-21": "382.93875",
  "2014-10-22": "376.59",
  "2014-10-23": "351.7825",
  "2014-10-24": "353.6325",
  "2014-10-25": "345.1925",
  "2014-10-26": "350.9775",
  "2014-10-27": "349.79625",
  "2014-10-28": "348.9025",
  "2014-10-29": "335.53625",
  "2014-10-30": "343.55875",
  "2014-10-31": "338.0105",
  "2014-11-01": "325.22633",
  "2014-11-02": "331.60083",
  "2014-11-03": "324.71833",
  "2014-11-04": "332.45666",
  "2014-11-05": "336.585",
  "2014-11-06": "346.775",
  "2014-11-07": "344.81166",
  "2014-11-08": "343.065",
  "2014-11-09": "358.50166",
  "2014-11-10": "368.07666",
  "2014-11-11": "376.99666",
  "2014-11-12": "442.10666",
  "2014-11-13": "389.00333",
  "2014-11-14": "394.92666",
  "2014-11-15": "377.08",
  "2014-11-16": "400.47166",
  "2014-11-17": "384.93",
  "2014-11-18": "375.83333",
  "2014-11-19": "376.16",
  "2014-11-20": "348.565",
  "2014-11-21": "352.42",
  "2014-11-22": "356.8",
  "2014-11-23": "367.83",
  "2014-11-24": "381.20666",
  "2014-11-25": "375.498",
  "2014-11-26": "372.819",
  "2014-11-27": "368.983",
  "2014-11-28": "375.44",
  "2014-11-29": "376.851",
  "2014-11-30": "376.13218",
  "2014-12-01": "377.862",
  "2014-12-02": "382.452",
  "2014-12-03": "376.382",
  "2014-12-04": "368.3618",
  "2014-12-05": "373.414",
  "2014-12-06": "373.744",
  "2014-12-07": "373.155",
  "2014-12-08": "357.884",
  "2014-12-09": "348.898",
  "2014-12-10": "341.041",
  "2014-12-11": "348.272",
  "2014-12-12": "346.742",
  "2014-12-13": "347.348",
  "2014-12-14": "348.674",
  "2014-12-15": "338.547",
  "2014-12-16": "330.536",
  "2014-12-17": "317.405",
  "2014-12-18": "306.45999",
  "2014-12-19": "319.196",
  "2014-12-20": "321.89299",
  "2014-12-21": "320.03499",
  "2014-12-22": "328.701",
  "2014-12-23": "332.053",
  "2014-12-24": "321.386",
  "2014-12-25": "318.563",
  "2014-12-26": "320.868",
  "2014-12-27": "316.009",
  "2014-12-28": "315.64",
  "2014-12-29": "313.994",
  "2014-12-30": "309.903",
  "2014-12-31": "317.204",
  "2015-01-01": "314.49899",
  "2015-01-02": "311.14099",
  "2015-01-03": "277.853",
  "2015-01-04": "270.813",
  "2015-01-05": "272.0175",
  "2015-01-06": "283.84125",
  "2015-01-07": "290.485",
  "2015-01-08": "281.03625",
  "2015-01-09": "286.688",
  "2015-01-10": "277.64999",
  "2015-01-11": "268.10199",
  "2015-01-12": "243.081",
  "2015-01-13": "219.128",
  "2015-01-14": "193.3511",
  "2015-01-15": "220.5745",
  "2015-01-16": "209.1655",
  "2015-01-17": "195.59467",
  "2015-01-18": "212.2711",
  "2015-01-19": "211.5401",
  "2015-01-20": "212.28249",
  "2015-01-21": "230.6754",
  "2015-01-22": "226.30419",
  "2015-01-23": "231.4242",
  "2015-01-24": "251.606",
  "2015-01-25": "283.59769",
  "2015-01-26": "258.5374",
  "2015-01-27": "257.447",
  "2015-01-28": "235.948",
  "2015-01-29": "233.141",
  "2015-01-30": "226.94116",
  "2015-01-31": "216.66066",
  "2015-02-01": "229.80441",
  "2015-02-02": "237.65175",
  "2015-02-03": "225.83858",
  "2015-02-04": "226.554",
  "2015-02-05": "219.75625",
  "2015-02-06": "225.46666",
  "2015-02-07": "225.73291",
  "2015-02-08": "222.78408",
  "2015-02-09": "220.16725",
  "2015-02-10": "223.00366",
  "2015-02-11": "218.72833",
  "2015-02-12": "223.96716",
  "2015-02-13": "237.65716",
  "2015-02-14": "256.21758",
  "2015-02-15": "230.1355",
  "2015-02-16": "235.71275",
  "2015-02-17": "242.93183",
  "2015-02-18": "237.1035",
  "2015-02-19": "241.07183",
  "2015-02-20": "245.70566",
  "2015-02-21": "245.145",
  "2015-02-22": "235.14141",
  "2015-02-23": "238.93183",
  "2015-02-24": "238.15225",
  "2015-02-25": "235.67716",
  "2015-02-26": "251.28908",
  "2015-02-27": "251.03416",
  "2015-02-28": "251.9314",
  "2015-03-01": "258.8485",
  "2015-03-02": "270.7625",
  "2015-03-03": "278.1172",
  "2015-03-04": "269.2606",
  "2015-03-05": "274.8977",
  "2015-03-06": "270.86109",
  "2015-03-07": "276.72789",
  "2015-03-08": "277.98519",
  "2015-03-09": "294.1886",
  "2015-03-10": "289.7149",
  "2015-03-11": "292.8678",
  "2015-03-12": "293.224",
  "2015-03-13": "282.644",
  "2015-03-14": "283.0809",
  "2015-03-15": "290.61579",
  "2015-03-16": "290.542",
  "2015-03-17": "283.7507",
  "2015-03-18": "252.44789",
  "2015-03-19": "263.4741",
  "2015-03-20": "259.913",
  "2015-03-21": "259.3943",
  "2015-03-22": "267.5549",
  "2015-03-23": "265.273",
  "2015-03-24": "246.6733",
  "2015-03-25": "245.6489",
  "2015-03-26": "246.5497",
  "2015-03-27": "248.4467",
  "2015-03-28": "246.728",
  "2015-03-29": "245.1133",
  "2015-03-30": "247.2639",
  "2015-03-31": "243.3028",
  "2015-04-01": "246.96",
  "2015-04-02": "252.0578",
  "2015-04-03": "253.4334",
  "2015-04-04": "252.0256",
  "2015-04-05": "260.3589",
  "2015-04-06": "252.0909",
  "2015-04-07": "252.8629",
  "2015-04-08": "244.0449",
  "2015-04-09": "240.9478",
  "2015-04-10": "236.4388",
  "2015-04-11": "236.5542",
  "2015-04-12": "235.522",
  "2015-04-13": "222.6009",
  "2015-04-14": "220.9126",
  "2015-04-15": "226.0171",
  "2015-04-16": "227.9255",
  "2015-04-17": "223.317",
  "2015-04-18": "223.4062",
  "2015-04-19": "223.9214",
  "2015-04-20": "224.9815",
  "2015-04-21": "235.50369",
  "2015-04-22": "234.15749",
  "2015-04-23": "233.40079",
  "2015-04-24": "228.92379",
  "2015-04-25": "219.94549",
  "2015-04-26": "219.19029",
  "2015-04-27": "227.3867",
  "2015-04-28": "225.3545",
  "2015-04-29": "225.9976",
  "2015-04-30": "236.6827",
  "2015-05-01": "233.8511",
  "2015-05-02": "236.2378",
  "2015-05-03": "240.3646",
  "2015-05-04": "235.6033",
  "2015-05-05": "235.6017",
  "2015-05-06": "230.4207",
  "2015-05-07": "237.059",
  "2015-05-08": "244.6989",
  "2015-05-09": "241.516",
  "2015-05-10": "239.4036",
  "2015-05-11": "240.00079",
  "2015-05-12": "241.3529",
  "2015-05-13": "235.5478",
  "2015-05-14": "237.5737",
  "2015-05-15": "236.657",
  "2015-05-16": "236.339",
  "2015-05-17": "236.2319",
  "2015-05-18": "233.3119",
  "2015-05-19": "232.7193",
  "2015-05-20": "234.204",
  "2015-05-21": "235.86329",
  "2015-05-22": "240.1588",
  "2015-05-23": "239.7985",
  "2015-05-24": "240.9415",
  "2015-05-25": "237.6588",
  "2015-05-26": "237.1844",
  "2015-05-27": "237.6708",
  "2015-05-28": "237.2277",
  "2015-05-29": "236.1404",
  "2015-05-30": "233.3328",
  "2015-05-31": "230.8331",
  "2015-06-01": "223.415",
  "2015-06-02": "226.6168",
  "2015-06-03": "225.444",
  "2015-06-04": "223.9665",
  "2015-06-05": "224.2525",
  "2015-06-06": "225.8403",
  "2015-06-07": "223.69459",
  "2015-06-08": "228.1884",
  "2015-06-09": "229.2025",
  "2015-06-10": "229.9599",
  "2015-06-11": "229.9082",
  "2015-06-12": "230.6695",
  "2015-06-13": "233.1445",
  "2015-06-14": "234.7473",
  "2015-06-15": "237.39899",
  "2015-06-16": "248.7435",
  "2015-06-17": "247.2359",
  "2015-06-18": "249.0733",
  "2015-06-19": "240.7897",
  "2015-06-20": "244.15625",
  "2015-06-21": "244.9588",
  "2015-06-22": "247.1273",
  "2015-06-23": "243.371",
  "2015-06-24": "240.9204",
  "2015-06-25": "242.31912",
  "2015-06-26": "242.28812",
  "2015-06-27": "250.382",
  "2015-06-28": "249.42725",
  "2015-06-29": "258.38549",
  "2015-06-30": "261.71749",
  "2015-07-01": "259.62937",
  "2015-07-02": "255.52675",
  "2015-07-03": "253.87887",
  "2015-07-04": "261.42899",
  "2015-07-05": "267.60762",
  "2015-07-06": "270.07587",
  "2015-07-07": "264.356",
  "2015-07-08": "267.943",
  "2015-07-09": "269.24925",
  "2015-07-10": "286.53662",
  "2015-07-11": "301.03837",
  "2015-07-12": "304.9905",
  "2015-07-13": "290.93137",
  "2015-07-14": "288.48787",
  "2015-07-15": "287.55762",
  "2015-07-16": "276.97924",
  "2015-07-17": "278.33337",
  "2015-07-18": "275.30687",
  "2015-07-19": "274.28387",
  "2015-07-20": "279.45925",
  "2015-07-21": "274.87242",
  "2015-07-22": "276.2095",
  "2015-07-23": "276.24491",
  "2015-07-24": "287.55583",
  "2015-07-25": "287.83983",
  "2015-07-26": "291.20091",
  "2015-07-27": "293.15058",
  "2015-07-28": "292.99425",
  "2015-07-29": "288.61658",
  "2015-07-30": "286.74491",
  "2015-07-31": "282.33741",
  "2015-08-01": "278.68258",
  "2015-08-02": "279.48591",
  "2015-08-03": "283.49091",
  "2015-08-04": "284.24366",
  "2015-08-05": "280.9375",
  "2015-08-06": "275.92866",
  "2015-08-07": "278.2765",
  "2015-08-08": "261.75225",
  "2015-08-09": "265.0825",
  "2015-08-10": "264.87516",
  "2015-08-11": "270.22325",
  "2015-08-12": "264.14299",
  "2015-08-13": "262.01758",
  "2015-08-14": "265.3955",
  "2015-08-15": "261.20058",
  "2015-08-16": "258.0065",
  "2015-08-17": "256.44841",
  "2015-08-18": "230.38424",
  "2015-08-19": "232.06483",
  "2015-08-20": "234.56375",
  "2015-08-21": "233.03691",
  "2015-08-22": "231.21275",
  "2015-08-23": "227.23233",
  "2015-08-24": "203.18133",
  "2015-08-25": "219.81583",
  "2015-08-26": "224.53608",
  "2015-08-27": "224.18875",
  "2015-08-28": "230.93575",
  "2015-08-29": "230.58541",
  "2015-08-30": "227.18083",
  "2015-08-31": "229.02966",
  "2015-09-01": "226.28841",
  "2015-09-02": "228.35299",
  "2015-09-03": "227.14741",
  "2015-09-04": "229.66691",
  "2015-09-05": "240.70116",
  "2015-09-06": "239.88",
  "2015-09-07": "242.01891",
  "2015-09-08": "244.31383",
  "2015-09-09": "237.99466",
  "2015-09-10": "240.56366",
  "2015-09-11": "239.81675",
  "2015-09-12": "235.053",
  "2015-09-13": "229.15808",
  "2015-09-14": "230.51091",
  "2015-09-15": "230.98066",
  "2015-09-16": "229.58975",
  "2015-09-17": "233.2385",
  "2015-09-18": "232.50008",
  "2015-09-19": "231.33733",
  "2015-09-20": "230.75433",
  "2015-09-21": "227.79358",
  "2015-09-22": "231.30983",
  "2015-09-23": "231.09508",
  "2015-09-24": "233.74475",
  "2015-09-25": "234.92466",
  "2015-09-26": "234.32908",
  "2015-09-27": "237.21116",
  "2015-09-28": "238.56625",
  "2015-09-29": "238.06125",
  "2015-09-30": "237.15191",
  "2015-10-01": "238.06358",
  "2015-10-02": "237.63516",
  "2015-10-03": "238.99883",
  "2015-10-04": "238.82433",
  "2015-10-05": "240.63075",
  "2015-10-06": "246.49633",
  "2015-10-07": "244.49816",
  "2015-10-08": "243.25675",
  "2015-10-09": "244.96533",
  "2015-10-10": "245.07",
  "2015-10-11": "247.65041",
  "2015-10-12": "244.57641",
  "2015-10-13": "249.45908",
  "2015-10-14": "254.64216",
  "2015-10-15": "255.72741",
  "2015-10-16": "267.53983",
  "2015-10-17": "270.04041",
  "2015-10-18": "264.98625",
  "2015-10-19": "264.92575",
  "2015-10-20": "270.49541",
  "2015-10-21": "267.46908",
  "2015-10-22": "274.25325",
  "2015-10-23": "279.97908",
  "2015-10-24": "286.86941",
  "2015-10-25": "284.286",
  "2015-10-26": "287.83091",
  "2015-10-27": "300.53566",
  "2015-10-28": "304.32691",
  "2015-10-29": "326.55691",
  "2015-10-30": "327.58425",
  "2015-10-31": "311.70274",
  "2015-11-01": "325.64666",
  "2015-11-02": "369.51133",
  "2015-11-03": "432.46133",
  "2015-11-04": "434.31683",
  "2015-11-05": "359.586",
  "2015-11-06": "377.64099",
  "2015-11-07": "387.775",
  "2015-11-08": "370.652",
  "2015-11-09": "376.948",
  "2015-11-10": "311.702",
  "2015-11-11": "320.036",
  "2015-11-12": "337.893",
  "2015-11-13": "334.125",
  "2015-11-14": "333.951",
  "2015-11-15": "320.06",
  "2015-11-16": "337.759",
  "2015-11-17": "333.33299",
  "2015-11-18": "334.02499",
  "2015-11-19": "315.63099",
  "2015-11-20": "321.482",
  "2015-11-21": "326.365",
  "2015-11-22": "322.606",
  "2015-11-23": "320.993",
  "2015-11-24": "318.337",
  "2015-11-25": "332.471",
  "2015-11-26": "349.138",
  "2015-11-27": "354.954",
  "2015-11-28": "356.806",
  "2015-11-29": "375.204",
  "2015-11-30": "377.798",
  "2015-12-01": "352.128",
  "2015-12-02": "366.788",
  "2015-12-03": "358.443",
  "2015-12-04": "369.956",
  "2015-12-05": "394.861",
  "2015-12-06": "391.618",
  "2015-12-07": "395.59299",
  "2015-12-08": "421.424",
  "2015-12-09": "415.076",
  "2015-12-10": "421.813",
  "2015-12-11": "467.831",
  "2015-12-12": "435.091",
  "2015-12-13": "437.021",
  "2015-12-14": "453.676",
  "2015-12-15": "445.805",
  "2015-12-16": "451.102",
  "2015-12-17": "456.425",
  "2015-12-18": "464.218",
  "2015-12-19": "460.238",
  "2015-12-20": "435.64099",
  "2015-12-21": "438.276",
  "2015-12-22": "437.994",
  "2015-12-23": "456.572",
  "2015-12-24": "455.743",
  "2015-12-25": "447.606",
  "2015-12-26": "419.338",
  "2015-12-27": "427.817",
  "2015-12-28": "422.741",
  "2015-12-29": "431.029",
  "2015-12-30": "424.962",
  "2015-12-31": "432.358",
  "2016-01-01": "433.773",
  "2016-01-02": "431.985",
  "2016-01-03": "431.691",
  "2016-01-04": "433.732",
  "2016-01-05": "427.164",
  "2016-01-06": "441.021",
  "2016-01-07": "457.168",
  "2016-01-08": "452.368",
  "2016-01-09": "445.327",
  "2016-01-10": "450.312",
  "2016-01-11": "446.614",
  "2016-01-12": "431.156",
  "2016-01-13": "431.41",
  "2016-01-14": "416.29",
  "2016-01-15": "372.737",
  "2016-01-16": "383.138",
  "2016-01-17": "380.817",
  "2016-01-18": "382.738",
  "2016-01-19": "378.775",
  "2016-01-20": "417.439",
  "2016-01-21": "403.271",
  "2016-01-22": "388.219",
  "2016-01-23": "388.538",
  "2016-01-24": "397.885",
  "2016-01-25": "390.715",
  "2016-01-26": "392.389",
  "2016-01-27": "381.356",
  "2016-01-28": "369.133",
  "2016-01-29": "376.952",
  "2016-01-30": "378.174",
  "2016-01-31": "372.157",
  "2016-02-01": "372.453",
  "2016-02-02": "372.762",
  "2016-02-03": "370.433",
  "2016-02-04": "386.954",
  "2016-02-05": "377.889",
  "2016-02-06": "376.44",
  "2016-02-07": "376.924",
  "2016-02-08": "372.434",
  "2016-02-09": "374.764",
  "2016-02-10": "379.186",
  "2016-02-11": "378.576",
  "2016-02-12": "388.87",
  "2016-02-13": "397.23",
  "2016-02-14": "405.621",
  "2016-02-15": "401.663",
  "2016-02-16": "407.017",
  "2016-02-17": "417.492",
  "2016-02-18": "421.956",
  "2016-02-19": "422.054",
  "2016-02-20": "439.61",
  "2016-02-21": "436.14",
  "2016-02-22": "438.745",
  "2016-02-23": "419.896",
  "2016-02-24": "422.617",
  "2016-02-25": "421.244",
  "2016-02-26": "433.401",
  "2016-02-27": "425.502",
  "2016-02-28": "438.28",
  "2016-02-29": "436.426",
  "2016-03-01": "434.001",
  "2016-03-02": "419.254",
  "2016-03-03": "421.597",
  "2016-03-04": "407.722",
  "2016-03-05": "397.883",
  "2016-03-06": "407.276",
  "2016-03-07": "414.213",
  "2016-03-08": "410.739",
  "2016-03-09": "411.672",
  "2016-03-10": "416.708",
  "2016-03-11": "415.04",
  "2016-03-12": "411.637",
  "2016-03-13": "414.208",
  "2016-03-14": "416.034",
  "2016-03-15": "414.167",
  "2016-03-16": "417.138",
  "2016-03-17": "417.154",
  "2016-03-18": "407.473",
  "2016-03-19": "409.24",
  "2016-03-20": "407.496",
  "2016-03-21": "415.125",
  "2016-03-22": "417.318",
  "2016-03-23": "415.837",
  "2016-03-24": "414.75699",
  "2016-03-25": "416.851",
  "2016-03-26": "416.233",
  "2016-03-27": "424.297",
  "2016-03-28": "423.597",
  "2016-03-29": "414.613",
  "2016-03-30": "414.458",
  "2016-03-31": "416.012",
  "2016-04-01": "418.785",
  "2016-04-02": "418.93999",
  "2016-04-03": "418.593",
  "2016-04-04": "422.044",
  "2016-04-05": "422.29499",
  "2016-04-06": "420.553",
  "2016-04-07": "421.616",
  "2016-04-08": "415.751",
  "2016-04-09": "418.078",
  "2016-04-10": "421.192",
  "2016-04-11": "426.383",
  "2016-04-12": "426.84399",
  "2016-04-13": "425.494",
  "2016-04-14": "426.279",
  "2016-04-15": "429.775",
  "2016-04-16": "430.453",
  "2016-04-17": "429.318",
  "2016-04-18": "428.522",
  "2016-04-19": "435.926",
  "2016-04-20": "443.758",
  "2016-04-21": "446.776",
  "2016-04-22": "447.233",
  "2016-04-23": "455.152",
  "2016-04-24": "458.626",
  "2016-04-25": "464.429",
  "2016-04-26": "466.064",
  "2016-04-27": "441.304",
  "2016-04-28": "446.236",
  "2016-04-29": "454.375",
  "2016-04-30": "449.108",
  "2016-05-01": "453.067",
  "2016-05-02": "443.681",
  "2016-05-03": "449.157",
  "2016-05-04": "447.73999",
  "2016-05-05": "447.58599",
  "2016-05-06": "458.864",
  "2016-05-07": "459.937",
  "2016-05-08": "458.708",
  "2016-05-09": "460.954",
  "2016-05-10": "454.39399",
  "2016-05-11": "451.155",
  "2016-05-12": "453.701",
  "2016-05-13": "456.039",
  "2016-05-14": "456.093",
  "2016-05-15": "457.64099",
  "2016-05-16": "454.278",
  "2016-05-17": "454.064",
  "2016-05-18": "453.494",
  "2016-05-19": "440.231",
  "2016-05-20": "442.953",
  "2016-05-21": "442.892",
  "2016-05-22": "440.551",
  "2016-05-23": "444.489",
  "2016-05-24": "447.035",
  "2016-05-25": "448.278",
  "2016-05-26": "467.262",
  "2016-05-27": "489.847",
  "2016-05-28": "516.051",
  "2016-05-29": "529.917",
  "2016-05-30": "537.23299",
  "2016-05-31": "528.04999",
  "2016-06-01": "538.568",
  "2016-06-02": "537.185",
  "2016-06-03": "571.139",
  "2016-06-04": "579.343",
  "2016-06-05": "578.84899",
  "2016-06-06": "585.399",
  "2016-06-07": "576.226",
  "2016-06-08": "580.43599",
  "2016-06-09": "574.953",
  "2016-06-10": "583.87",
  "2016-06-11": "633.205",
  "2016-06-12": "682.226",
  "2016-06-13": "695.155",
  "2016-06-14": "685.442",
  "2016-06-15": "732.357",
  "2016-06-16": "773.25",
  "2016-06-17": "736.386",
  "2016-06-18": "747.831",
  "2016-06-19": "758.903",
  "2016-06-20": "702.696",
  "2016-06-21": "657.013",
  "2016-06-22": "581.249",
  "2016-06-23": "657.08999",
  "2016-06-24": "687.168",
  "2016-06-25": "657.22399",
  "2016-06-26": "644.091",
  "2016-06-27": "655.94399",
  "2016-06-28": "634.357",
  "2016-06-29": "635.093",
  "2016-06-30": "683.293",
  "2016-07-01": "678.567",
  "2016-07-02": "690.179",
  "2016-07-03": "670.741",
  "2016-07-04": "679.351",
  "2016-07-05": "676.872",
  "2016-07-06": "671.814",
  "2016-07-07": "640.476",
  "2016-07-08": "654.85299",
  "2016-07-09": "649.356",
  "2016-07-10": "656.747",
  "2016-07-11": "648.136",
  "2016-07-12": "663.443",
  "2016-07-13": "654.018",
  "2016-07-14": "663.638",
  "2016-07-15": "666.56499",
  "2016-07-16": "665.113",
  "2016-07-17": "681.239",
  "2016-07-18": "673.832",
  "2016-07-19": "673.008",
  "2016-07-20": "662.034",
  "2016-07-21": "666.747",
  "2016-07-22": "654.725",
  "2016-07-23": "654.895",
  "2016-07-24": "660.284",
  "2016-07-25": "655.418",
  "2016-07-26": "650.82899",
  "2016-07-27": "656.91599",
  "2016-07-28": "655.427",
  "2016-07-29": "656.681",
  "2016-07-30": "635.588",
  "2016-07-31": "621.37299",
  "2016-08-01": "601.227",
  "2016-08-02": "555.926",
  "2016-08-03": "578.52374",
  "2016-08-04": "570.33875",
  "2016-08-05": "574.87375",
  "2016-08-06": "588.51625",
  "2016-08-07": "589.66125",
  "2016-08-08": "586.715",
  "2016-08-09": "585.23875",
  "2016-08-10": "594.81625",
  "2016-08-11": "581.9625",
  "2016-08-12": "584.87375",
  "2016-08-13": "581.65",
  "2016-08-14": "571.9625",
  "2016-08-15": "567.60749",
  "2016-08-16": "575.54125",
  "2016-08-17": "572.37249",
  "2016-08-18": "573.01625",
  "2016-08-19": "573.08",
  "2016-08-20": "581.35375",
  "2016-08-21": "579.6675",
  "2016-08-22": "585.5075",
  "2016-08-23": "577.98749",
  "2016-08-24": "574.5825",
  "2016-08-25": "575.0625",
  "2016-08-26": "575.3425",
  "2016-08-27": "568.78875",
  "2016-08-28": "574.49749",
  "2016-08-29": "571.94125",
  "2016-08-30": "573.78125",
  "2016-08-31": "572.96",
  "2016-09-01": "570.1",
  "2016-09-02": "572.52125",
  "2016-09-03": "596.45375",
  "2016-09-04": "606.0525",
  "2016-09-05": "604.465",
  "2016-09-06": "609.4325",
  "2016-09-07": "613.67499",
  "2016-09-08": "623.6",
  "2016-09-09": "620.59875",
  "2016-09-10": "622.03375",
  "2016-09-11": "604.8275",
  "2016-09-12": "607.03625",
  "2016-09-13": "606.885",
  "2016-09-14": "606.8975",
  "2016-09-15": "605.52125",
  "2016-09-16": "606.04625",
  "2016-09-17": "605.08",
  "2016-09-18": "609.37249",
  "2016-09-19": "606.7175",
  "2016-09-20": "595.93375",
  "2016-09-21": "596.225",
  "2016-09-22": "595.0175",
  "2016-09-23": "602.4075",
  "2016-09-24": "601.36875",
  "2016-09-25": "598.9075",
  "2016-09-26": "605.0175",
  "2016-09-27": "602.885",
  "2016-09-28": "603.58124",
  "2016-09-29": "604.52125",
  "2016-09-30": "610.58375",
  "2016-10-01": "613.23749",
  "2016-10-02": "611.88874",
  "2016-10-03": "609.495",
  "2016-10-04": "608.125",
  "2016-10-05": "610.57",
  "2016-10-06": "610.23375",
  "2016-10-07": "617.445",
  "2016-10-08": "614.59625",
  "2016-10-09": "615.91625",
  "2016-10-10": "618.3275",
  "2016-10-11": "637.21624",
  "2016-10-12": "637.73625",
  "2016-10-13": "635.88375",
  "2016-10-14": "638.975",
  "2016-10-15": "638.605",
  "2016-10-16": "636.635",
  "2016-10-17": "637.01625",
  "2016-10-18": "634.605",
  "2016-10-19": "626.36875",
  "2016-10-20": "629.61249",
  "2016-10-21": "630.61875",
  "2016-10-22": "650.895",
  "2016-10-23": "647.69375",
  "2016-10-24": "652.235",
  "2016-10-25": "657.05625",
  "2016-10-26": "684.3775",
  "2016-10-27": "684.2975",
  "2016-10-28": "700.135",
  "2016-10-29": "704.91",
  "2016-10-30": "693.89625",
  "2016-10-31": "708.955",
  "2016-11-01": "725.6925",
  "2016-11-02": "741.84875",
  "2016-11-03": "701.21875",
  "2016-11-04": "702.175",
  "2016-11-05": "705.47875",
  "2016-11-06": "705.47125",
  "2016-11-07": "706.13375",
  "2016-11-08": "728.36125",
  "2016-11-09": "719.2525",
  "2016-11-10": "714.57125",
  "2016-11-11": "715.7725",
  "2016-11-12": "694.72125",
  "2016-11-13": "704.62125",
  "2016-11-14": "711.39625",
  "2016-11-15": "710.9275",
  "2016-11-16": "745.92625",
  "2016-11-17": "738.665",
  "2016-11-18": "748.8075",
  "2016-11-19": "752.5525",
  "2016-11-20": "730.365",
  "2016-11-21": "734.84",
  "2016-11-22": "745.97875",
  "2016-11-23": "739.81875",
  "2016-11-24": "730.3125",
  "2016-11-25": "737.4025",
  "2016-11-26": "727.445",
  "2016-11-27": "731.9",
  "2016-11-28": "731.12625",
  "2016-11-29": "731.64",
  "2016-11-30": "744.1025",
  "2016-12-01": "766.5925",
  "2016-12-02": "769.915",
  "2016-12-03": "764.3575",
  "2016-12-04": "760.1",
  "2016-12-05": "754.82625",
  "2016-12-06": "758.35375",
  "2016-12-07": "763.23625",
  "2016-12-08": "766.8725",
  "2016-12-09": "773.2825",
  "2016-12-10": "765.9525",
  "2016-12-11": "769.8275",
  "2016-12-12": "774.38625",
  "2016-12-13": "778.35625",
  "2016-12-14": "776.9825",
  "2016-12-15": "776.415",
  "2016-12-16": "786.9725",
  "2016-12-17": "789.24625",
  "2016-12-18": "791",
  "2016-12-19": "789.2325",
  "2016-12-20": "805.79625",
  "2016-12-21": "842.63875",
  "2016-12-22": "910.9325",
  "2016-12-23": "910.2475",
  "2016-12-24": "870.13125",
  "2016-12-25": "905.45625",
  "2016-12-26": "900.36625",
  "2016-12-27": "948.89875",
  "2016-12-28": "971.645",
  "2016-12-29": "954.84375",
  "2016-12-30": "952.455",
  "2016-12-31": "964.325",
  "2017-01-01": "1009.97375",
  "2017-01-02": "1028.33375",
  "2017-01-03": "1047.09999",
  "2017-01-04": "1140.385",
  "2017-01-05": "985.93875",
  "2017-01-06": "837.83625",
  "2017-01-07": "923.52375",
  "2017-01-08": "889.33875",
  "2017-01-09": "905.22625",
  "2017-01-10": "910.60625",
  "2017-01-11": "772.66125",
  "2017-01-12": "784.89375",
  "2017-01-13": "820.68875",
  "2017-01-14": "821.19625",
  "2017-01-15": "830.74",
  "2017-01-16": "848.58125",
  "2017-01-17": "890.29375",
  "2017-01-18": "888.0625",
  "2017-01-19": "896.16375",
  "2017-01-20": "920.58875",
  "2017-01-21": "934.7775",
  "2017-01-22": "920.365",
  "2017-01-23": "912.2125",
  "2017-01-24": "898.55",
  "2017-01-25": "901.05",
  "2017-01-26": "912.84375",
  "2017-01-27": "919.795",
  "2017-01-28": "920.82875",
  "2017-01-29": "916.91125",
  "2017-01-30": "921.35125",
  "2017-01-31": "973.065",
  "2017-02-01": "982.8275",
  "2017-02-02": "1020.09",
  "2017-02-03": "1011.215",
  "2017-02-04": "1029.40124",
  "2017-02-05": "1019.3125",
  "2017-02-06": "1029.40875",
  "2017-02-07": "1067.70875",
  "2017-02-08": "1072.205",
  "2017-02-09": "974.95875",
  "2017-02-10": "997.2275",
  "2017-02-11": "1004.71375",
  "2017-02-12": "1004.85375",
  "2017-02-13": "994.58",
  "2017-02-14": "1003.59",
  "2017-02-15": "1018.41125",
  "2017-02-16": "1038.86625",
  "2017-02-17": "1058.315",
  "2017-02-18": "1052.84375",
  "2017-02-19": "1046.66249",
  "2017-02-20": "1079.5825",
  "2017-02-21": "1112.86375",
  "2017-02-22": "1122.515",
  "2017-02-23": "1193.501",
  "2017-02-24": "1182.429",
  "2017-02-25": "1139.848",
  "2017-02-26": "1189.366",
  "2017-02-27": "1189.94699",
  "2017-02-28": "1193.611",
  "2017-03-01": "1221.05",
  "2017-03-02": "1269.776",
  "2017-03-03": "1285.376",
  "2017-03-04": "1260.668",
  "2017-03-05": "1273.24699",
  "2017-03-06": "1280.30499",
  "2017-03-07": "1206.357",
  "2017-03-08": "1153.06",
  "2017-03-09": "1200.557",
  "2017-03-10": "1147.625",
  "2017-03-11": "1186.351",
  "2017-03-12": "1235.553",
  "2017-03-13": "1242.806",
  "2017-03-14": "1245.892",
  "2017-03-15": "1247.67099",
  "2017-03-16": "1126.08199",
  "2017-03-17": "1062.07",
  "2017-03-18": "1000.24599",
  "2017-03-19": "1036.226",
  "2017-03-20": "1065.481",
  "2017-03-21": "1091.333",
  "2017-03-22": "1036.099",
  "2017-03-23": "1013.844",
  "2017-03-24": "921.808",
  "2017-03-25": "962.508",
  "2017-03-26": "968.293",
  "2017-03-27": "1035.32199",
  "2017-03-28": "1011.969",
  "2017-03-29": "1041.374",
  "2017-03-30": "1048.86299",
  "2017-03-31": "1077.557",
  "2017-04-01": "1082.37",
  "2017-04-02": "1140.037",
  "2017-04-03": "1148.092",
  "2017-04-04": "1139.86",
  "2017-04-05": "1150.685",
  "2017-04-06": "1177.284",
  "2017-04-07": "1196.896",
  "2017-04-08": "1187.03299",
  "2017-04-09": "1213.801",
  "2017-04-10": "1206.74",
  "2017-04-11": "1226.896",
  "2017-04-12": "1216.269",
  "2017-04-13": "1187.136",
  "2017-04-14": "1186.10899",
  "2017-04-15": "1189.55",
  "2017-04-16": "1184.2",
  "2017-04-17": "1211.73799",
  "2017-04-18": "1218.666",
  "2017-04-19": "1227.981",
  "2017-04-20": "1261.702",
  "2017-04-21": "1255.25125",
  "2017-04-22": "1232.7575",
  "2017-04-23": "1243.43",
  "2017-04-24": "1251.5775",
  "2017-04-25": "1269.69625",
  "2017-04-26": "1289.7475",
  "2017-04-27": "1335.825",
  "2017-04-28": "1319.7",
  "2017-04-29": "1311.58874",
  "2017-04-30": "1370.79",
  "2017-05-01": "1416.61",
  "2017-05-02": "1448.88625",
  "2017-05-03": "1506.7725",
  "2017-05-04": "1543.31",
  "2017-05-05": "1536.1525",
  "2017-05-06": "1554.6025",
  "2017-05-07": "1564.065",
  "2017-05-08": "1644.72875",
  "2017-05-09": "1695.83125",
  "2017-05-10": "1748.35375",
  "2017-05-11": "1774.52",
  "2017-05-12": "1634.6075",
  "2017-05-13": "1774.805",
  "2017-05-14": "1747.04375",
  "2017-05-15": "1665.0325",
  "2017-05-16": "1744.44125",
  "2017-05-17": "1796.89625",
  "2017-05-18": "1913.13875",
  "2017-05-19": "1983.97875",
  "2017-05-20": "2074.69625",
  "2017-05-21": "2114.98875",
  "2017-05-22": "2196.66874",
  "2017-05-23": "2348.55249",
  "2017-05-24": "2581.85375",
  "2017-05-25": "2460.95375",
  "2017-05-26": "2232.2875",
  "2017-05-27": "2234.83374",
  "2017-05-28": "2195.785",
  "2017-05-29": "2315.73625",
  "2017-05-30": "2170.98124",
  "2017-05-31": "2402.125",
  "2017-06-01": "2477.1725",
  "2017-06-02": "2475.2975",
  "2017-06-03": "2526.31125",
  "2017-06-04": "2605.125",
  "2017-06-05": "2855.03",
  "2017-06-06": "2900.8525",
  "2017-06-07": "2737.9025",
  "2017-06-08": "2826.03875",
  "2017-06-09": "2846.00625",
  "2017-06-10": "2910.33625",
  "2017-06-11": "3007.0125",
  "2017-06-12": "2697.0775",
  "2017-06-13": "2780.1825",
  "2017-06-14": "2518.54875",
  "2017-06-15": "2438.61749",
  "2017-06-16": "2520.78375",
  "2017-06-17": "2680.1025",
  "2017-06-18": "2611.67999",
  "2017-06-19": "2667.5475",
  "2017-06-20": "2805.0975",
  "2017-06-21": "2702.00375",
  "2017-06-22": "2763.29125",
  "2017-06-23": "2740.5925",
  "2017-06-24": "2598.15875",
  "2017-06-25": "2630.59499",
  "2017-06-26": "2513.42999",
  "2017-06-27": "2556.1675",
  "2017-06-28": "2591.2675",
  "2017-06-29": "2547.3225",
  "2017-06-30": "2479.05499",
  "2017-07-01": "2424.69875",
  "2017-07-02": "2513.74125",
  "2017-07-03": "2640.06125",
  "2017-07-04": "2588.67875",
  "2017-07-05": "2634.17375",
  "2017-07-06": "2598.57",
  "2017-07-07": "2514.3625",
  "2017-07-08": "2586.0425",
  "2017-07-09": "2524.12624",
  "2017-07-10": "2352.265",
  "2017-07-11": "2292.91375",
  "2017-07-12": "2437.55375",
  "2017-07-13": "2337.67875",
  "2017-07-14": "2109.37375",
  "2017-07-15": "2045.5725",
  "2017-07-16": "1986.9425",
  "2017-07-17": "2189.23999",
  "2017-07-18": "2354.8925",
  "2017-07-19": "2349.355",
  "2017-07-20": "2740.56875",
  "2017-07-21": "2738.775",
  "2017-07-22": "2831.67875",
  "2017-07-23": "2772.3675",
  "2017-07-24": "2768.8025",
  "2017-07-25": "2540.20874",
  "2017-07-26": "2570.195",
  "2017-07-27": "2699.72125",
  "2017-07-28": "2719.69",
  "2017-07-29": "2714.70375",
  "2017-07-30": "2718.6175",
  "2017-07-31": "2867.65375",
  "2017-08-01": "2739.70875",
  "2017-08-02": "2740.07125",
  "2017-08-03": "2811.71",
  "2017-08-04": "3123.41125",
  "2017-08-05": "3254.71",
  "2017-08-06": "3274.6375",
  "2017-08-07": "3474.7625",
  "2017-08-08": "3416.185",
  "2017-08-09": "3364.41125",
  "2017-08-10": "3451.8525",
  "2017-08-11": "3705.43",
  "2017-08-12": "4104.015",
  "2017-08-13": "4036.7575",
  "2017-08-14": "4462.67625",
  "2017-08-15": "4118.9025",
  "2017-08-16": "4322.42125",
  "2017-08-17": "4311.685",
  "2017-08-18": "4180.23875",
  "2017-08-19": "4139.38125",
  "2017-08-20": "4110.94125",
  "2017-08-21": "3911.27625",
  "2017-08-22": "4162.79249",
  "2017-08-23": "4178.75625",
  "2017-08-24": "4396.03125",
  "2017-08-25": "4359.9025",
  "2017-08-26": "4381.39625",
  "2017-08-27": "4340.46",
  "2017-08-28": "4442.6575",
  "2017-08-29": "4664.64375",
  "2017-08-30": "4676.1425",
  "2017-08-31": "4783.17",
  "2017-09-01": "4864.285",
  "2017-09-02": "4672.56875",
  "2017-09-03": "4593.1825",
  "2017-09-04": "4160.535",
  "2017-09-05": "4517.57",
  "2017-09-06": "4543.1025",
  "2017-09-07": "4628.6025",
  "2017-09-08": "4280.975",
  "2017-09-09": "4194.21875",
  "2017-09-10": "4307.82625",
  "2017-09-11": "4295.76124",
  "2017-09-12": "3944.58375",
  "2017-09-13": "3817.0575",
  "2017-09-14": "3358.10875",
  "2017-09-15": "3772.68375",
  "2017-09-16": "3608.595",
  "2017-09-17": "3764.6175",
  "2017-09-18": "3976.3875",
  "2017-09-19": "3863.18625",
  "2017-09-20": "3827.685",
  "2017-09-21": "3690.99125",
  "2017-09-22": "3612.1625",
  "2017-09-23": "3772.8475",
  "2017-09-24": "3753.435",
  "2017-09-25": "3920.99125",
  "2017-09-26": "3939.515",
  "2017-09-27": "4220.28",
  "2017-09-28": "4062.20375",
  "2017-09-29": "4207.825",
  "2017-09-30": "4300.55125",
  "2017-10-01": "4414.1775",
  "2017-10-02": "4424.4725",
  "2017-10-03": "4307.555",
  "2017-10-04": "4186.78374",
  "2017-10-05": "4325.23625",
  "2017-10-06": "4370.16875",
  "2017-10-07": "4446.17249",
  "2017-10-08": "4624.34875",
  "2017-10-09": "4789.30125",
  "2017-10-10": "4741.70875",
  "2017-10-11": "4858.60499",
  "2017-10-12": "5728.5475",
  "2017-10-13": "5666.97875",
  "2017-10-14": "5779.07375",
  "2017-10-15": "5607.01",
  "2017-10-16": "5643.55375",
  "2017-10-17": "5495.03875",
  "2017-10-18": "5627.08625",
  "2017-10-19": "5686.52625",
  "2017-10-20": "6098.115",
  "2017-10-21": "5949.07875",
  "2017-10-22": "5969.795",
  "2017-10-23": "5649.005",
  "2017-10-24": "5550.85875",
  "2017-10-25": "5776.87875",
  "2017-10-26": "5923.70625",
  "2017-10-27": "5737.1025",
  "2017-10-28": "5741.7225",
  "2017-10-29": "6151.325",
  "2017-10-30": "6130.56375",
  "2017-10-31": "6424.515",
  "2017-11-01": "6879.365",
  "2017-11-02": "7199.2375",
  "2017-11-03": "7210.46875",
  "2017-11-04": "7376.7425",
  "2017-11-05": "7231.93",
  "2017-11-06": "7123.89375",
  "2017-11-07": "7356.50625",
  "2017-11-08": "7342.82375",
  "2017-11-09": "7250.77",
  "2017-11-10": "6773.695",
  "2017-11-11": "6075.30125",
  "2017-11-12": "5969.13",
  "2017-11-13": "6666.27125",
  "2017-11-14": "6867.42625",
  "2017-11-15": "7259.3",
  "2017-11-16": "7924.1825",
  "2017-11-17": "7598.2775",
  "2017-11-18": "7787.45625",
  "2017-11-19": "7954.7675",
  "2017-11-20": "7879.06",
  "2017-11-21": "8150.6325",
  "2017-11-22": "8208.75375",
  "2017-11-23": "8094.445",
  "2017-11-24": "8190.87125",
  "2017-11-25": "8851.305",
  "2017-11-26": "9573.9675",
  "2017-11-27": "9713.09625",
  "2017-11-28": "10295.6225",
  "2017-11-29": "10542.6625",
  "2017-11-30": "9706.10375",
  "2017-12-01": "10923.20125",
  "2017-12-02": "10973.54375",
  "2017-12-03": "11382.20875",
  "2017-12-04": "11597.23125",
  "2017-12-05": "12230.365",
  "2017-12-06": "13734.52",
  "2017-12-07": "16403.42125",
  "2017-12-08": "15732.1",
  "2017-12-09": "13152.52875",
  "2017-12-10": "16299.2975",
  "2017-12-11": "16374.8975",
  "2017-12-12": "16678.28749",
  "2017-12-13": "16246.13875",
  "2017-12-14": "17221.65125",
  "2017-12-15": "17436.5975",
  "2017-12-16": "19166.97874",
  "2017-12-17": "18640.2625",
  "2017-12-18": "18984.7675",
  "2017-12-19": "16862.57125",
  "2017-12-20": "16925.0175",
  "2017-12-21": "14182.46499",
  "2017-12-22": "14694.5825",
  "2017-12-23": "14103.21875",
  "2017-12-24": "13387.34875",
  "2017-12-25": "14652.3675",
  "2017-12-26": "15846.07375",
  "2017-12-27": "14362.40375",
  "2017-12-28": "14867.5725",
  "2017-12-29": "13643.695",
  "2017-12-30": "13062.145",
  "2017-12-31": "13439.4175",
  "2018-01-01": "13337.62125",
  "2018-01-02": "14881.545",
  "2018-01-03": "15104.45",
  "2018-01-04": "14953.8525",
  "2018-01-05": "16576.69625",
  "2018-01-06": "16735.10625",
  "2018-01-07": "15632.41125",
  "2018-01-08": "15242.93625",
  "2018-01-09": "14122.825",
  "2018-01-10": "13269.5975",
  "2018-01-11": "13633.36375",
  "2018-01-12": "14165.90625",
  "2018-01-13": "14217.3625",
  "2018-01-14": "13519.92625",
  "2018-01-15": "12915.11625",
  "2018-01-16": "10870.16875",
  "2018-01-17": "11340.65",
  "2018-01-18": "11137.36875",
  "2018-01-19": "11742.94125",
  "2018-01-20": "12486.06625",
  "2018-01-21": "11508.62",
  "2018-01-22": "10872.9025",
  "2018-01-23": "10830.9275",
  "2018-01-24": "11629.375",
  "2018-01-25": "11524.345",
  "2018-01-26": "11005.615",
  "2018-01-27": "11452.23",
  "2018-01-28": "11412.79375",
  "2018-01-29": "10917.15125",
  "2018-01-30": "9914.4725",
  "2018-01-31": "9970.30875",
  "2018-02-01": "8715.59499",
  "2018-02-02": "8285.50124",
  "2018-02-03": "9192.045",
  "2018-02-04": "8136.39",
  "2018-02-05": "6332.37",
  "2018-02-06": "7270.5075",
  "2018-02-07": "7987.28125",
  "2018-02-08": "8086.7725",
  "2018-02-09": "8930.13875",
  "2018-02-10": "8045.44",
  "2018-02-11": "8478.92499",
  "2018-02-12": "8766.8525",
  "2018-02-13": "8693.2525",
  "2018-02-14": "9659.2875",
  "2018-02-15": "10110.83875",
  "2018-02-16": "10474.77125",
  "2018-02-17": "10855.9375",
  "2018-02-18": "10537.00625",
  "2018-02-19": "11416.03875",
  "2018-02-20": "10928.02",
  "2018-02-21": "10727.9525",
  "2018-02-22": "9809.72125",
  "2018-02-23": "10412.36875",
  "2018-02-24": "9585.285",
  "2018-02-25": "9627.71625",
  "2018-02-26": "10272.9025",
  "2018-02-27": "10903.01875",
  "2018-02-28": "10352.04625",
  "2018-03-01": "11100.2925",
  "2018-03-02": "11305.1225",
  "2018-03-03": "11171.8175",
  "2018-03-04": "11558.475",
  "2018-03-05": "11246.7475",
  "2018-03-06": "10735.88625",
  "2018-03-07": "9552.75875",
  "2018-03-08": "8980.19249",
  "2018-03-09": "9251.2925",
  "2018-03-10": "8680.6075",
  "2018-03-11": "9433.47374",
  "2018-03-12": "9047.5125",
  "2018-03-13": "9260.70875",
  "2018-03-14": "7895.98875",
  "2018-03-15": "8039.6025",
  "2018-03-16": "8206.555",
  "2018-03-17": "7667.99",
  "2018-03-18": "8189.49125",
  "2018-03-19": "8597.3375",
  "2018-03-20": "9028.2975",
  "2018-03-21": "9023.7175",
  "2018-03-22": "8411.6525",
  "2018-03-23": "8881.98625",
  "2018-03-24": "8548.8125",
  "2018-03-25": "8429.33124",
  "2018-03-26": "7854.6375",
  "2018-03-27": "7863.255",
  "2018-03-28": "7866.36",
  "2018-03-29": "6861.325",
  "2018-03-30": "6970.36375",
  "2018-03-31": "6926.875",
  "2018-04-01": "6986.835",
  "2018-04-02": "7182.12",
  "2018-04-03": "7295.89",
  "2018-04-04": "6769.48375",
  "2018-04-05": "6766.5925",
  "2018-04-06": "6854.92125",
  "2018-04-07": "6964.4325",
  "2018-04-08": "7125.53875",
  "2018-04-09": "6789.2675",
  "2018-04-10": "6824.49375",
  "2018-04-11": "6941.63875",
  "2018-04-12": "7823.55875",
  "2018-04-13": "8040.88125",
  "2018-04-14": "8083.57375",
  "2018-04-15": "8160.4125",
  "2018-04-16": "8030.57",
  "2018-04-17": "7937.61",
  "2018-04-18": "8188.71875",
  "2018-04-19": "8333.81374",
  "2018-04-20": "8866.67",
  "2018-04-21": "8830.05875",
  "2018-04-22": "8868.16124",
  "2018-04-23": "9191.82",
  "2018-04-24": "9373.3025",
  "2018-04-25": "8807.515",
  "2018-04-26": "9153.64125",
  "2018-04-27": "9144.38375",
  "2018-04-28": "9444.1425",
  "2018-04-29": "9268.7175",
  "2018-04-30": "8949.87624",
  "2018-05-01": "9029.47875",
  "2018-05-02": "9228.8525",
  "2018-05-03": "9572.69875",
  "2018-05-04": "9817.5975",
  "2018-05-05": "9845.54375",
  "2018-05-06": "9326.76125",
  "2018-05-07": "9424.99124",
  "2018-05-08": "9039.02875",
  "2018-05-09": "9327.04999",
  "2018-05-10": "8920.25625",
  "2018-05-11": "8408.35875",
  "2018-05-12": "8442.23875",
  "2018-05-13": "8398.86249",
  "2018-05-14": "8711.38875",
  "2018-05-15": "8159.25625",
  "2018-05-16": "8360.22875",
  "2018-05-17": "7996.82125",
  "2018-05-18": "8237.3425",
  "2018-05-19": "8250.395",
  "2018-05-20": "8493.13125",
  "2018-05-21": "8324.025",
  "2018-05-22": "7951.51375",
  "2018-05-23": "7614.96375",
  "2018-05-24": "7599.9525",
  "2018-05-25": "7436.835",
  "2018-05-26": "7296.79625",
  "2018-05-27": "7383.2175",
  "2018-05-28": "7118.42375",
  "2018-05-29": "7491.61125",
  "2018-05-30": "7363.27625",
  "2018-05-31": "7490.62125",
  "2018-06-01": "7518.333328931",
  "2018-06-02": "7630.403388155",
  "2018-06-03": "7716.1450680606",
  "2018-06-04": "7505.5892769261",
  "2018-06-05": "7624.1879705558",
  "2018-06-11": "6780.3408026703",
  "2018-06-12": "6525.329181606",
  "2018-06-13": "6321.6559647806",
  "2018-06-14": "6601.3241577351",
  "2018-06-15": "6397.4411699407",
  "2018-06-16": "6529.5440149899",
  "2018-06-17": "6482.8686968609",
  "2018-06-18": "6711.6496699796",
  "2018-06-19": "6731.7101466428",
  "2018-06-20": "6736.8677212375",
  "2018-06-21": "6729.9259369514",
  "2018-06-22": "6099.445277341",
  "2018-06-23": "6198.7008235859",
  "2018-06-24": "6142.3925697055",
  "2018-06-25": "6244.3284549671",
  "2018-06-26": "6148.4227054114",
  "2018-06-27": "6140.1914995488",
  "2018-06-28": "5954.5265818138",
  "2018-06-29": "6189.3092519378",
  "2018-06-30": "6343.8921999592",
  "2018-07-01": "6373.2778541204",
  "2018-07-02": "6629.7495948521",
  "2018-07-03": "6482.8305936314",
  "2018-07-04": "6589.6327930083",
  "2018-07-05": "6538.6824323422",
  "2018-07-07": "6570.4275920965",
  "2018-07-08": "6744.9886791676",
  "2018-07-09": "6694.5308510827",
  "2018-07-10": "6364.3875895982",
  "2018-07-11": "6360.4466681956",
  "2018-07-12": "6144.8101179498",
  "2018-07-14": "6254.6781291793",
  "2018-07-15": "6366.3499035552",
  "2018-07-16": "6671.6259190668",
  "2018-07-17": "7315.5510403376",
  "2018-07-18": "7359.7370183427",
  "2018-07-19": "7484.6396703854",
  "2018-07-20": "7357.4456773198",
  "2018-07-21": "7424.7342378111",
  "2018-07-22": "7411.2005247349",
  "2018-07-23": "7730.2474798128",
  "2018-07-24": "8325.8015336658",
  "2018-07-25": "8271.5979196832",
  "2018-07-26": "7925.2473958792",
  "2018-07-27": "8254.2773483423",
  "2018-07-28": "8184.6955351747",
  "2018-07-29": "8201.8900899474",
  "2018-07-30": "8166.3883602012",
  "2018-07-31": "7700.8341285235",
  "2018-08-01": "7588.5861802231",
  "2018-08-02": "7547.3149505122",
  "2018-08-03": "7423.0743779862",
  "2018-08-04": "7396.0411215425",
  "2018-08-05": "7411.5152993623",
  "2018-08-06": "7402.3366337439",
  "2018-08-07": "6748.4414841816",
  "2018-08-08": "6460.1531550102",
  "2018-08-09": "6482.9734487615",
  "2018-08-10": "6092.5331036604",
  "2018-08-11": "6391.5992583652",
  "2018-08-12": "6338.7389567451",
  "2018-08-13": "6260.1929950271",
  "2018-08-14": "6123.4476006082",
  "2018-08-15": "6332.6068999281",
  "2018-08-16": "6273.8880695393",
  "2018-08-17": "6566.5952833952",
  "2018-08-18": "6396.9463686172",
  "2018-08-19": "6516.6683821435",
  "2018-08-20": "6299.3953331255",
  "2018-08-21": "6470.7335666523",
  "2018-08-22": "6355.8818088457",
  "2018-08-23": "6503.8323619614",
  "2018-08-24": "6675.3606827832",
  "2018-08-25": "6725.0323269894",
  "2018-08-26": "6689.8226825962",
  "2018-08-27": "6756.6289258733",
  "2018-08-28": "7084.2936167368",
  "2018-08-29": "7059.2312352573",
  "2018-08-30": "6938.9145822993",
  "2018-08-31": "7028.447311566",
  "2018-09-01": "7198.0584362259",
  "2018-09-02": "7282.8585138311",
  "2018-09-03": "7260.2515925593",
  "2018-09-04": "7361.2718642376",
  "2018-09-05": "6913.1150129363",
  "2018-09-06": "6471.493883654",
  "2018-09-07": "6400.2687056583",
  "2018-09-08": "6181.7442069566",
  "2018-09-09": "6253.9372013424",
  "2018-09-10": "6275.0831321787",
  "2018-09-11": "6275.6695882724",
  "2018-09-12": "6277.4944091253",
  "2018-09-13": "6283.1841998225",
  "2018-09-14": "6285.9824663114",
  "2018-09-15": "6280.3101068801",
  "2018-09-16": "6281.4093556542",
  "2018-09-17": "6273.2200825643",
  "2018-09-18": "6278.5954861797",
  "2018-09-19": "6282.6107265937",
  "2018-09-20": "6288.0701702962",
  "2018-09-21": "6317.6996850165",
  "2018-09-22": "6293.8364208374",
  "2018-09-23": "6289.6213269847",
  "2018-09-24": "6466.9945639118",
  "2018-09-25": "6391.3859805928",
  "2018-09-26": "6509.7766212475",
  "2018-09-27": "6698.4160468789",
  "2018-09-28": "6502.6881513173",
  "2018-09-29": "6576.6143197",
  "2018-09-30": "6647.3879467315",
  "2018-10-01": "6603.7543420461",
  "2018-10-02": "6576.3542289419",
  "2018-10-03": "6481.2457703264",
  "2018-10-04": "6594.9357857858",
  "2018-10-05": "6630.5752970678",
  "2018-10-06": "6595.2603262611",
  "2018-10-07": "6591.6863183363",
  "2018-10-08": "6662.8684995573",
  "2018-10-09": "6663.021070746",
  "2018-10-10": "6619.4958451381",
  "2018-10-11": "6285.859202643",
  "2018-10-12": "6309.1989214047",
  "2018-10-13": "6331.1311540774",
  "2018-10-14": "6361.4170162729",
  "2018-10-15": "6721.5875032778",
  "2018-10-16": "6724.8330778968",
  "2018-10-17": "6444.7470095938",
  "2018-10-18": "6374.6488625469",
  "2018-10-19": "6372.6868170702",
  "2018-10-20": "6407.4790849086",
  "2018-10-21": "6412.5304907339",
  "2018-10-22": "6396.8801542538",
  "2018-10-23": "6396.252324044",
  "2018-10-24": "6407.667175231",
  "2018-10-25": "6405.5007258241",
  "2018-10-26": "6392.1793373833",
  "2018-10-27": "6436.355483928",
  "2018-10-28": "6429.6871414323",
  "2018-10-29": "6266.1896827178",
  "2018-10-30": "6276.4644997238",
  "2018-10-31": "6321.713671307",
  "2018-11-01": "6341.0948126498",
  "2018-11-02": "6360.1412719216",
  "2018-11-03": "6344.7389429436",
  "2018-11-04": "6405.1397546807",
  "2018-11-05": "6396.3521235412",
  "2018-11-06": "6425.9178018185",
  "2018-11-07": "6514.4894527375",
  "2018-11-08": "6412.524289058",
  "2018-11-09": "6343.6325037562",
  "2018-11-10": "6365.655231516",
  "2018-11-11": "6327.4806461044",
  "2018-11-12": "6327.1546960646",
  "2018-11-13": "6282.4386771629",
  "2018-11-14": "5524.8010934193",
  "2018-11-15": "5511.1528335321",
  "2018-11-16": "5448.6006335653",
  "2018-11-17": "5497.4112787322",
  "2018-11-18": "5553.014895008",
  "2018-11-19": "4800.3428974568",
  "2018-11-20": "4246.3127740611",
  "2018-11-21": "4478.2995582941",
  "2018-11-22": "4405.7440313629",
  "2018-11-23": "4329.9172203207",
  "2018-11-24": "3728.8726484882",
  "2018-11-25": "3951.20502915",
  "2018-11-26": "3640.5571648024",
  "2018-11-27": "3792.1923641199",
  "2018-11-28": "4174.31997237",
  "2018-11-29": "4218.6083631146",
  "2018-11-30": "3952.4478953992",
  "2018-12-01": "4178.60382773",
  "2018-12-02": "4118.5182417699",
  "2018-12-03": "3847.0327374089",
  "2018-12-04": "3889.2921196935",
  "2018-12-05": "3713.5733827508",
  "2018-12-06": "3578.2066240384",
  "2018-12-07": "3391.8741459694",
  "2018-12-08": "3452.6161853921",
  "2018-12-09": "3507.3063671956",
  "2018-12-10": "3419.7337684576",
  "2018-12-11": "3360.9466282566",
  "2018-12-12": "3414.8337488292",
  "2018-12-13": "3263.5479129873",
  "2018-12-14": "3212.207080727",
  "2018-12-15": "3194.96227244",
  "2018-12-16": "3200.6424680869",
  "2018-12-17": "3478.461202649",
  "2018-12-18": "3562.8949463603",
  "2018-12-19": "3709.3167592101",
  "2018-12-20": "4065.7999528499",
  "2018-12-21": "3824.7397939051",
  "2018-12-22": "3862.7263286473",
  "2018-12-23": "3949.7943416583",
  "2018-12-24": "4054.2962598168",
  "2018-12-25": "3767.3500239009",
  "2018-12-26": "3807.1530224727",
  "2018-12-27": "3587.1982229208",
  "2018-12-28": "3865.5293004371",
  "2018-12-31": "3689.5646203364",
  "2019-01-01": "3715.5644411293",
  "2019-01-02": "3882.304754348",
  "2019-01-03": "3795.5927412969",
  "2019-01-04": "3812.3811076791",
  "2019-01-05": "3809.9143429619",
  "2019-01-06": "4014.1331870739",
  "2019-01-07": "3989.6317409326",
  "2019-01-08": "3992.9861439065",
  "2019-01-09": "3995.3251931641",
  "2019-01-10": "3617.3462911588",
  "2019-01-11": "3606.1648903844",
  "2019-01-12": "3611.5282378524",
  "2019-01-13": "3497.6693915005",
  "2019-01-14": "3654.3470673605",
  "2019-01-15": "3568.7512587366",
  "2019-01-16": "3593.7217397683",
  "2019-01-17": "3623.717336702",
  "2019-01-18": "3605.8551868777",
  "2019-01-19": "3690.9085636878",
  "2019-01-20": "3544.2217242808",
  "2019-01-21": "3528.4635294479",
  "2019-01-22": "3581.5519472363",
  "2019-01-23": "3549.770799097",
  "2019-01-24": "3562.9204764613",
  "2019-01-25": "3566.6661636996",
  "2019-01-26": "3563.2780095528",
  "2019-01-27": "3539.6209472447",
  "2019-01-28": "3425.2621611882",
  "2019-01-29": "3395.0186452497",
  "2019-01-30": "3441.0322154158",
  "2019-01-31": "3420.633226576",
  "2019-02-01": "3439.8056988758",
  "2019-02-02": "3433.0352852216",
  "2019-02-03": "3404.499313399",
  "2019-02-04": "3412.2304311019",
  "2019-02-05": "3419.7678987458",
  "2019-02-06": "3367.5190315823",
  "2019-02-07": "3360.534075862",
  "2019-02-08": "3591.0221518825",
  "2019-02-09": "3617.4646801319",
  "2019-02-10": "3621.1540027134",
  "2019-02-11": "3593.1831765659",
  "2019-02-12": "3579.3418810265",
  "2019-02-13": "3569.5548327757",
  "2019-02-14": "3558.3968581047",
  "2019-02-15": "3566.2477646317",
  "2019-02-16": "3596.4051912371",
  "2019-02-17": "3606.1519884106",
  "2019-02-18": "3865.3181649793",
  "2019-02-19": "3904.4829202328",
  "2019-02-20": "3924.7398439211",
  "2019-02-21": "3889.7584851849",
  "2019-02-22": "3933.6075896328",
  "2019-02-23": "4105.1127585961",
  "2019-02-24": "3763.6205157956",
  "2019-02-25": "3819.8653414425",
  "2019-02-26": "3797.5817895103",
  "2019-02-27": "3772.9363353275",
  "2019-02-28": "3799.678542951",
  "2019-03-01": "3811.6119793671",
  "2019-03-02": "3804.4191701095",
  "2019-03-03": "3782.6641011218",
  "2019-03-04": "3689.8628931904",
  "2019-03-05": "3832.0808847342",
  "2019-03-06": "3848.9563696825",
  "2019-03-07": "3859.8399833296",
  "2019-03-08": "3828.3719040694",
  "2019-03-09": "3898.8684595605",
  "2019-03-10": "3899.6558689562",
  "2019-03-11": "3851.2491896498",
  "2019-03-12": "3866.2959463248",
  "2019-03-13": "3846.2744415121",
  "2019-03-14": "3855.7443626577",
  "2019-03-15": "3892.0523011383",
  "2019-03-16": "3985.8512364813",
  "2019-03-17": "3970.3890446061",
  "2019-03-18": "3974.4157640954",
  "2019-03-19": "3996.037130764",
  "2019-03-20": "4027.7873954939",
  "2019-03-21": "3974.8114294551",
  "2019-03-22": "3987.3052249052",
  "2019-03-23": "3977.707443288",
  "2019-03-24": "3968.4387009854",
  "2019-03-25": "3913.7817170518",
  "2019-03-26": "3915.3753197805",
  "2019-03-27": "4018.5905096995",
  "2019-03-28": "4008.3708718477",
  "2019-03-29": "4080.2601141916",
  "2019-03-30": "4081.2216046987",
  "2019-03-31": "4094.7047913777",
  "2019-04-01": "4135.1849399747",
  "2019-04-02": "4818.7706353498",
  "2019-04-03": "5102.1507526415",
  "2019-04-04": "4875.5994313973",
  "2019-04-05": "5030.9332705867",
  "2019-04-06": "5028.3210819427",
  "2019-04-07": "5198.1731702888",
  "2019-04-08": "5260.2050430865",
  "2019-04-09": "5179.997649218",
  "2019-04-10": "5283.543757825",
  "2019-04-11": "5049.6058235388",
  "2019-04-12": "5077.5158640878",
  "2019-04-13": "5066.8670401606",
  "2019-04-14": "5158.3874010066",
  "2019-04-15": "5045.6751659083",
  "2019-04-16": "5184.2044677779",
  "2019-04-17": "5220.9599338197",
  "2019-04-18": "5276.5589823291",
  "2019-04-19": "5266.6612458779",
  "2019-04-20": "5292.1483296981",
  "2019-04-21": "5276.5583181647",
  "2019-04-22": "5398.4334166027",
  "2019-04-23": "5552.5219105461",
  "2019-04-24": "5432.9910174238",
  "2019-04-25": "5132.227526274",
  "2019-04-26": "5151.5745281681",
  "2019-04-27": "5200.1932393191",
  "2019-04-28": "5152.5457396305",
  "2019-04-29": "5151.4334996793",
  "2019-04-30": "5277.4444688896",
  "2019-05-01": "5297.9424922151",
  "2019-05-02": "5405.8780670084",
  "2019-05-03": "5697.6790537992",
  "2019-05-04": "5812.3317793033",
  "2019-05-05": "5713.0350518135",
  "2019-05-06": "5706.0084207883",
  "2019-05-07": "5899.5296934602",
  "2019-05-08": "5932.4413913918",
  "2019-05-09": "6159.6859018287",
  "2019-05-10": "6387.829450439",
  "2019-05-11": "7254.8055361621",
  "2019-05-12": "6992.7066614624",
  "2019-05-13": "7906.9408350528",
  "2019-05-14": "7928.4174163467",
  "2019-05-15": "8177.4535191838",
  "2019-05-16": "7820.0762428219",
  "2019-05-17": "7243.650538964",
  "2019-05-18": "7295.6497288231",
  "2019-05-19": "8221.2593953546",
  "2019-05-20": "7917.0124987984",
  "2019-05-21": "7961.1287431622",
  "2019-05-22": "7723.9038796248",
  "2019-05-23": "7903.8469103955",
  "2019-05-24": "8038.5067907549",
  "2019-05-25": "8089.5701634982",
  "2019-05-26": "8653.1423680221",
  "2019-05-27": "8800.3466061527",
  "2019-05-28": "8719.3314849999",
  "2019-05-29": "8672.4001072907",
  "2019-05-30": "8287.0402563223",
  "2019-05-31": "8513.2038819334",
  "2019-06-01": "8588.4795049694",
  "2019-06-02": "8744.2655607165",
  "2019-06-03": "8474.0482291229",
  "2019-06-04": "7645.5725139007",
  "2019-06-05": "7790.3211349552",
  "2019-06-06": "7730.8817258862",
  "2019-06-07": "8030.2560794416",
  "2019-06-08": "7949.425798625",
  "2019-06-09": "7600.9224920885",
  "2019-06-10": "7954.0062377205",
  "2019-06-11": "7903.6252503798",
  "2019-06-12": "8151.7886797815",
  "2019-06-13": "8256.7200994618",
  "2019-06-14": "8667.7879539941",
  "2019-06-15": "8836.1684129096",
  "2019-06-16": "9061.5404606385",
  "2019-06-17": "9346.9750871976",
  "2019-06-18": "9012.4878496522",
  "2019-06-19": "9259.1236383919",
  "2019-06-20": "9559.9006885716",
  "2019-06-21": "9906.407965055",
  "2019-06-22": "10461.4121688088",
  "2019-06-23": "10843.5709747797",
  "2019-06-24": "10996.4597495353",
  "2019-06-25": "11665.4096837335",
  "2019-06-26": "12444.9258599878",
  "2019-06-27": "11086.2688286526",
  "2019-06-28": "12316.9530120207",
  "2019-06-29": "12024.0809722046",
  "2019-06-30": "10932.3105071733",
  "2019-07-01": "10454.6838183291",
  "2019-07-02": "10800.1301399504",
  "2019-07-03": "11942.2402247929",
  "2019-07-04": "11645.5246063376",
  "2019-07-05": "10946.2090547386",
  "2019-07-06": "11219.0460004352",
  "2019-07-07": "11422.1144680283",
  "2019-07-08": "12335.9993946484",
  "2019-07-09": "12575.904067439",
  "2019-07-10": "12054.1837934894",
  "2019-07-11": "11324.1446969751",
  "2019-07-12": "11802.9599635884",
  "2019-07-13": "11279.6027356333",
  "2019-07-14": "10506.3958273087",
  "2019-07-15": "10934.4827395525",
  "2019-07-16": "9490.4105157548",
  "2019-07-17": "9733.1321340919",
  "2019-07-18": "10603.3488731713",
  "2019-07-19": "10466.2609381509",
  "2019-07-20": "10983.2160020296",
  "2019-07-21": "10551.1316333347",
  "2019-07-22": "10285.6392306749",
  "2019-07-23": "10027.5326122485",
  "2019-07-24": "9771.5047613175",
  "2019-07-25": "9897.4293515161",
  "2019-07-26": "9812.2263505784",
  "2019-07-27": "9440.1400373076",
  "2019-07-28": "9495.855261405",
  "2019-07-29": "9506.704273142",
  "2019-07-30": "9572.735371803",
  "2019-07-31": "10005.2944733245",
  "2019-08-01": "10385.2006061246",
  "2019-08-02": "10513.9114715942",
  "2019-08-03": "10831.2598554087",
  "2019-08-04": "10985.8075416287",
  "2019-08-05": "11811.7870541507",
  "2019-08-06": "11310.187223605",
  "2019-08-07": "11956.0472230184",
  "2019-08-08": "11817.4554825164",
  "2019-08-09": "11827.5745716918",
  "2019-08-10": "11278.2812549022",
  "2019-08-11": "11485.3657829898",
  "2019-08-12": "11391.9686539038",
  "2019-08-13": "10869.3791128623",
  "2019-08-14": "10211.4985816982",
  "2019-08-15": "10386.5395500195",
  "2019-08-16": "10388.4505925604",
  "2019-08-17": "10212.1014417394",
  "2019-08-18": "10335.3728385716",
  "2019-08-19": "10774.8103058331",
  "2019-08-20": "10818.5070076193",
  "2019-08-21": "10064.9167944793",
  "2019-08-22": "10161.1647494901",
  "2019-08-23": "10364.2813536875",
  "2019-08-24": "10171.4974606754",
  "2019-08-25": "10068.922419922",
  "2019-08-26": "10312.2150398496",
  "2019-08-27": "10122.1965329581",
  "2019-08-28": "9743.1620510451",
  "2019-08-29": "9487.9764335192",
  "2019-08-30": "9590.7363369227",
  "2019-08-31": "9624.9839105321",
  "2019-09-01": "9780.6678970327",
  "2019-09-02": "10381.8559592516",
  "2019-09-03": "10691.31129913",
  "2019-09-04": "10555.0469008368",
  "2019-09-05": "10576.3178915251",
  "2019-09-06": "10334.0238858467",
  "2019-09-07": "10495.2273642085",
  "2019-09-08": "10402.7965306911",
  "2019-09-09": "10332.9421881057",
  "2019-09-10": "10082.9468264833",
  "2019-09-11": "10152.7529840771",
  "2019-09-12": "10396.7672047403",
  "2019-09-13": "10299.4769604855",
  "2019-09-14": "10351.2320218437",
  "2019-09-15": "10302.1907136783",
  "2019-09-16": "10301.6596516938",
  "2019-09-17": "10231.4215119596",
  "2019-09-18": "10168.2877093815",
  "2019-09-19": "10223.5055788024",
  "2019-09-20": "10138.3352052234",
  "2019-09-21": "9984.520515967",
  "2019-09-22": "10031.8667089936",
  "2019-09-23": "9719.7186961077",
  "2019-09-24": "8688.9735259572",
  "2019-09-25": "8438.7085524873",
  "2019-09-26": "8103.2108995944",
  "2019-09-27": "8195.2106969967",
  "2019-09-28": "8146.4140320046",
  "2019-09-29": "8085.7132904218",
  "2019-09-30": "8241.3414700027",
  "2019-10-01": "8333.6891904217",
  "2019-10-02": "8273.4640176573",
  "2019-10-03": "8203.8438327979",
  "2019-10-04": "8163.9026381024",
  "2019-10-05": "8137.1466890387",
  "2019-10-06": "7853.6933048347",
  "2019-10-07": "8236.2083793045",
  "2019-10-08": "8201.6378181926",
  "2019-10-09": "8572.3808124348",
  "2019-10-10": "8582.1445177037",
  "2019-10-11": "8320.1715813968",
  "2019-10-12": "8328.6042603935",
  "2019-10-13": "8282.1773258265",
  "2019-10-14": "8337.8189985374",
  "2019-10-16": "8003.8203947876",
  "2019-10-17": "8058.0580811125",
  "2019-10-18": "7970.2394756046",
  "2019-10-19": "7943.3471070605",
  "2019-10-20": "8200.3187633988",
  "2019-10-21": "8200.2460994923",
  "2019-10-22": "8073.4095438836",
  "2019-10-23": "7420.4158364928",
  "2019-10-24": "7460.6174159279",
  "2019-10-25": "8591.2238974163",
  "2019-10-26": "9171.3065318558",
  "2019-10-27": "9578.3675560737",
  "2019-10-28": "9458.2233596272",
  "2019-10-29": "9455.7246926058",
  "2019-10-30": "9225.9954793378",
  "2019-10-31": "9131.4106303055",
  "2019-11-01": "9197.6323446207",
  "2019-11-02": "9290.8966023936",
  "2019-11-03": "9202.41545055",
  "2019-11-04": "9369.6280811552",
  "2019-11-05": "9326.5996237841",
  "2019-11-06": "9335.7524023305",
  "2019-11-07": "9226.4858208826",
  "2019-11-08": "8794.3586445233",
  "2019-11-09": "8798.0420546256",
  "2019-11-10": "9081.1868784913",
  "2019-11-11": "8711.5343391679",
  "2019-11-12": "8760.8927181435",
  "2019-11-13": "8749.520591019",
  "2019-11-14": "8656.970922354",
  "2019-11-15": "8500.6435581622",
  "2019-11-16": "8469.2608988992",
  "2019-11-17": "8537.3396519676",
  "2019-11-18": "8205.8063659942",
  "2019-11-19": "8118.4885358003",
  "2019-11-20": "8074.8431736099",
  "2019-11-21": "7612.7405735024",
  "2019-11-22": "7262.1105349483",
  "2019-11-23": "7303.4057585242",
  "2019-11-24": "7041.7329364242",
  "2019-11-25": "7211.8618087461",
  "2019-11-26": "7141.0694486947",
  "2019-11-27": "7523.4806726005",
  "2019-11-28": "7390.207469227",
  "2019-11-29": "7729.265938935",
  "2019-11-30": "7542.2356086361",
  "2019-12-01": "7381.9630078152",
  "2019-12-02": "7333.4329304881",
  "2019-12-03": "7315.3677645579",
  "2019-12-04": "7213.7337617194",
  "2019-12-05": "7398.7870496069",
  "2019-12-06": "7511.8805831153",
  "2019-12-07": "7532.1235130864",
  "2019-12-08": "7550.2391998746",
  "2019-12-09": "7333.0960431601",
  "2019-12-10": "7239.762575441",
  "2019-12-11": "7198.0666770463",
  "2019-12-12": "7190.2723692612",
  "2019-12-13": "7238.8743229875",
  "2019-12-14": "7087.0249853497",
  "2019-12-15": "7112.7314761241",
  "2019-12-16": "6883.4963937703",
  "2019-12-17": "6584.0288433458",
  "2019-12-18": "7424.0154002314",
  "2019-12-19": "7147.5683237876",
  "2019-12-20": "7139.9333705301",
  "2019-12-21": "7286.3350811573",
  "2019-12-22": "7236.9862046092",
  "2019-12-23": "7166.1723785327",
  "2019-12-24": "7235.6266504955",
  "2019-12-25": "7212.8093952216",
  "2019-12-26": "7183.7065360296",
  "2019-12-27": "7227.2937116818",
  "2019-12-28": "7311.560643923",
  "2019-12-29": "7385.464847913",
  "2019-12-30": "7251.2767943228",
  "2019-12-31": "7179.9578192867",
  "2020-01-01": "7174.7440119511",
  "2020-01-02": "6955.4875796712",
  "2020-01-03": "7291.2195053189",
  "2020-01-04": "7337.6366701377",
  "2020-01-05": "7347.4332644392",
  "2020-01-06": "7713.8607536496",
  "2020-01-07": "8039.6037008183",
  "2020-01-08": "8067.6063690564",
  "2020-01-09": "7808.7013638165",
  "2020-01-10": "8087.4528852359",
  "2020-01-11": "8078.9935319903",
  "2020-01-12": "8149.3137171468",
  "2020-01-13": "8116.9610079465",
  "2020-01-14": "8735.1424391365",
  "2020-01-15": "8843.6757322237",
  "2020-01-16": "8711.6375778988",
  "2020-01-17": "8925.2990284456",
  "2020-01-18": "8939.8643002492",
  "2020-01-19": "8638.1814404614",
  "2020-01-20": "8652.6837629859",
  "2020-01-21": "8708.786013433",
  "2020-01-22": "8635.0743569587",
  "2020-01-23": "8384.0887767671",
  "2020-01-24": "8451.2322960209",
  "2020-01-25": "8347.567505406",
  "2020-01-26": "8562.307470442",
  "2020-01-27": "8881.9623914604",
  "2020-01-28": "9131.1149880642",
  "2020-01-29": "9320.9784062486",
  "2020-01-30": "9545.0779565894",
  "2020-01-31": "9388.8807518859",
  "2020-02-01": "9363.1933827575",
  "2020-02-02": "9385.2603858419",
  "2020-02-03": "9269.7070348447",
  "2020-02-04": "9177.8946372066",
  "2020-02-05": "9625.4566372011",
  "2020-02-06": "9681.3774113095",
  "2020-02-07": "9795.3440659492",
  "2020-02-08": "9927.7782564213",
  "2020-02-09": "10132.706499106",
  "2020-02-10": "9838.9000162764",
  "2020-02-11": "10236.6351482326",
  "2020-02-12": "10364.9262882252",
  "2020-02-13": "10218.0997373046",
  "2020-02-14": "10367.5279981077",
  "2020-02-15": "9926.353690569",
  "2020-02-16": "9876.2349632052",
  "2020-02-17": "9636.6240948155",
  "2020-02-18": "10189.9959829746",
  "2020-02-19": "9701.0371914987",
  "2020-02-20": "9631.4849459561",
  "2020-02-21": "9670.8586543715",
  "2020-02-22": "9689.0867428481",
  "2020-02-23": "9919.5514478418",
  "2020-02-24": "9640.4695050585",
  "2020-02-25": "9392.8696287195",
  "2020-02-26": "8787.9783631624",
  "2020-02-27": "8784.9953524383",
  "2020-02-28": "8778.4705108021",
  "2020-02-29": "8639.5914172977",
  "2020-03-01": "8548.9483224221",
  "2020-03-02": "8923.0443982559",
  "2020-03-03": "8791.1120581303",
  "2020-03-04": "8756.9610624113",
  "2020-03-05": "9078.5787771302",
  "2020-03-06": "9126.6368222216",
  "2020-03-07": "8925.2134877789",
  "2020-03-08": "8166.3138940249",
  "2020-03-09": "7875.7508752183",
  "2020-03-10": "7959.2282742121",
  "2020-03-11": "7955.3062841815",
  "2020-03-12": "5800.2089048343",
  "2020-03-13": "5672.6812010316",
  "2020-03-14": "5304.149952186",
  "2020-03-15": "5355.1873735338",
  "2020-03-16": "4944.7023359837",
  "2020-03-17": "5465.582594124",
  "2020-03-18": "5363.8228532507",
  "2020-03-19": "6301.0634040737",
  "2020-03-20": "6185.2798385235",
  "2020-03-21": "6187.0537502172",
  "2020-03-22": "5884.3401334651",
  "2020-03-23": "6455.4546882515",
  "2020-03-24": "6784.3180114254",
  "2020-03-25": "6706.9850891337",
  "2020-03-26": "6721.4953923809",
  "2020-03-27": "6682.7800491951",
  "2020-03-28": "6229.4883428258",
  "2020-03-29": "5922.4898350924",
  "2020-03-30": "6483.7394455297",
  "2020-03-31": "6446.4213468415",
  "2020-04-01": "6537.3364615033",
  "2020-04-02": "6850.5587116906",
  "2020-04-03": "6776.370093566",
  "2020-04-04": "6855.9332644576",
  "2020-04-05": "6805.3622868989",
  "2020-04-06": "7278.2439697658",
  "2020-04-07": "7175.6674765579",
  "2020-04-08": "7367.2933984502",
  "2020-04-09": "7321.8166138877",
  "2020-04-10": "6866.3981890103",
  "2020-04-11": "6873.848495157",
  "2020-04-12": "7043.4388635241",
  "2020-04-13": "6889.8637723481",
  "2020-04-14": "6887.554907833",
  "2020-04-15": "6718.7999502834",
  "2020-04-16": "7166.5828171387",
  "2020-04-17": "7065.0823890422",
  "2020-04-18": "7277.1405855631",
  "2020-04-19": "7185.87030343",
  "2020-04-20": "6856.1464345446",
  "2020-04-21": "6904.4757726979",
  "2020-04-22": "7118.3887479246",
  "2020-04-23": "7562.0328317455",
  "2020-04-24": "7497.8617638281",
  "2020-04-25": "7542.3034007032",
  "2020-04-26": "7624.8537859232",
  "2020-04-27": "7776.5075425684",
  "2020-04-28": "7761.7587840758",
  "2020-04-29": "8773.1064879583",
  "2020-04-30": "8767.6726233679",
  "2020-05-01": "8853.7744840141",
  "2020-05-02": "8963.057557797",
  "2020-05-03": "8904.713816537",
  "2020-05-04": "8887.5058925872",
  "2020-05-05": "8978.2835871237",
  "2020-05-06": "9371.6842727917",
  "2020-05-07": "9900.678866615",
  "2020-05-08": "9917.2484143422",
  "2020-05-09": "9617.5181949278",
  "2020-05-10": "8786.655181651",
  "2020-05-11": "8608.125245038",
  "2020-05-12": "8815.2312449023",
  "2020-05-13": "9330.986484701",
  "2020-05-14": "9757.2965855933",
  "2020-05-15": "9362.6355569661",
  "2020-05-16": "9418.9185505051",
  "2020-05-17": "9684.7019593528",
  "2020-05-18": "9723.6801504531",
  "2020-05-19": "9719.4808544776",
  "2020-05-20": "9540.8865665842",
  "2020-05-21": "9141.150637421",
  "2020-05-22": "9192.8451358053",
  "2020-05-23": "9220.0758874664",
  "2020-05-24": "9048.7151191611",
  "2020-05-25": "8905.7816045384",
  "2020-05-26": "8835.7272240409",
  "2020-05-27": "9112.9791755927",
  "2020-05-28": "9507.5246646633",
  "2020-05-29": "9425.2818691896",
  "2020-05-30": "9688.324390372",
  "2020-05-31": "9427.6700841394",
  "2020-06-01": "10268.5819847333",
  "2020-06-02": "9516.1354430882",
  "2020-06-03": "9667.0607542595",
  "2020-06-04": "9811.367094602",
  "2020-06-05": "9659.6612981892",
  "2020-06-06": "9677.0509945125",
  "2020-06-07": "9737.458558786",
  "2020-06-08": "9791.9278997681",
  "2020-06-09": "9786.1420204782",
  "2020-06-10": "9874.967047524",
  "2020-06-11": "9260.8326409877",
  "2020-06-12": "9464.2280968215",
  "2020-06-13": "9458.6597544046",
  "2020-06-14": "9351.9537280097",
  "2020-06-15": "9441.7689955465",
  "2020-06-16": "9510.6606372934",
  "2020-06-17": "9457.6270744096",
  "2020-06-18": "9398.6420936216",
  "2020-06-19": "9279.7607651662",
  "2020-06-20": "9353.0781961865",
  "2020-06-21": "9289.104491444",
  "2020-06-22": "9680.9471278957",
  "2020-06-23": "9609.6802455253",
  "2020-06-24": "9311.1363183171",
  "2020-06-25": "9252.6333717662",
  "2020-06-26": "9171.7320857653",
  "2020-06-27": "9022.1537680028",
  "2020-06-28": "9101.8500573564",
  "2020-06-29": "9188.0613754617",
  "2020-06-30": "9148.4448585576",
  "2020-07-01": "9236.3167704303",
  "2020-07-02": "9097.7973663897",
  "2020-07-03": "9094.3245610188",
  "2020-07-04": "9124.653534398",
  "2020-07-05": "9055.4644825162",
  "2020-07-06": "9278.8056370407",
  "2020-07-07": "9244.4158145353",
  "2020-07-08": "9471.7599734203",
  "2020-07-09": "9236.1432537083",
  "2020-07-10": "9243.1752591504",
  "2020-07-11": "9229.85975494",
  "2020-07-12": "9286.737042085",
  "2020-07-13": "9238.9937548587",
  "2020-07-14": "9260.4709801845",
  "2020-07-15": "9211.0264328947",
  "2020-07-16": "9133.7778303426",
  "2020-07-17": "9160.4105914881",
  "2020-07-18": "9176.6863901004",
  "2020-07-19": "9190.2715341962",
  "2020-07-20": "9172.5883325719",
  "2020-07-21": "9395.0644458829",
  "2020-07-22": "9530.7908853474",
  "2020-07-23": "9617.3778613786",
  "2020-07-24": "9568.9747259614",
  "2020-07-25": "9708.9491400965",
  "2020-07-26": "9938.9512228609",
  "2020-07-27": "11187.7797269617",
  "2020-07-28": "10939.6701415471",
  "2020-07-29": "11284.4589868467",
  "2020-07-30": "11118.918412434",
  "2020-07-31": "11373.3172566418",
  "2020-08-01": "11766.7482970949",
  "2020-08-02": "11139.0983803526",
  "2020-08-03": "11261.8063317402",
  "2020-08-04": "11228.0263240165",
  "2020-08-05": "11653.4075855619",
  "2020-08-06": "11796.8173649898",
  "2020-08-07": "11639.9354101265",
  "2020-08-08": "11744.9120755023",
  "2020-08-09": "11673.1232375366",
  "2020-08-10": "11832.2273081293",
  "2020-08-11": "11340.5823406437",
  "2020-08-12": "11549.5463143706",
  "2020-08-13": "11752.1686562261",
  "2020-08-14": "11783.2834112599",
  "2020-08-15": "11895.6269498904",
  "2020-08-16": "11896.9471701861",
  "2020-08-17": "12399.1118846619",
  "2020-08-18": "12071.738909085",
  "2020-08-19": "11749.8295087584",
  "2020-08-20": "11833.8973486966",
  "2020-08-21": "11583.1389426341",
  "2020-08-22": "11674.6243539052",
  "2020-08-23": "11666.4101222366",
  "2020-08-24": "11744.0126966495",
  "2020-08-25": "11378.7260298071",
  "2020-08-26": "11458.8225964867",
  "2020-08-27": "11302.1209644988",
  "2020-08-28": "11482.2256865058",
  "2020-08-29": "11515.0444306934",
  "2020-08-30": "11657.0039342288",
  "2020-08-31": "11678.3732554192",
  "2020-09-01": "11964.2086724627",
  "2020-09-02": "11427.7026049712",
  "2020-09-03": "10712.9206460713",
  "2020-09-04": "10563.896938616",
  "2020-09-05": "10042.8548543675",
  "2020-09-06": "10207.6050029603",
  "2020-09-07": "10381.7761069335",
  "2020-09-08": "10043.1964412914",
  "2020-09-09": "10268.460915747",
  "2020-09-10": "10341.0159838502",
  "2020-09-11": "10380.5395972283",
  "2020-09-12": "10436.3654083593",
  "2020-09-13": "10313.06857949",
  "2020-09-14": "10680.2975611652",
  "2020-09-15": "10829.5053071986",
  "2020-09-16": "11033.3835264817",
  "2020-09-17": "10937.1112591004",
  "2020-09-18": "10933.9311623986",
  "2020-09-19": "11048.8792781597",
  "2020-09-20": "10852.9101389415",
  "2020-09-21": "10526.2028872017",
  "2020-09-22": "10531.1645626345",
  "2020-09-23": "10260.0330124118",
  "2020-09-24": "10672.956808056",
  "2020-09-25": "10729.0696074184",
  "2020-09-26": "10741.4764675217",
  "2020-09-27": "10752.3454497531",
  "2020-09-28": "10863.0657239052",
  "2020-09-29": "10764.2843707196",
  "2020-09-30": "10741.5795494951",
  "2020-10-01": "10626.6009564965",
  "2020-10-02": "10567.330195233",
  "2020-10-03": "10555.0286787811",
  "2020-10-04": "10660.6111826447",
  "2020-10-05": "10756.4045849204",
  "2020-10-06": "10589.6263935253",
  "2020-10-07": "10645.7547867781",
  "2020-10-08": "10897.5954315054",
  "2020-10-09": "11052.3950836712",
  "2020-10-10": "11360.8527168674",
  "2020-10-11": "11334.0267420322",
  "2020-10-12": "11666.2117003214",
  "2020-10-13": "11443.7327918222",
  "2020-10-14": "11395.54736637",
  "2020-10-15": "11504.5490067109",
  "2020-10-16": "11355.1604394509",
  "2020-10-17": "11358.7063796297",
  "2020-10-18": "11471.002547787",
  "2020-10-19": "11776.5929973295",
  "2020-10-20": "11936.3629133377",
  "2020-10-21": "13102.9344615485",
  "2020-10-22": "13140.669284056",
  "2020-10-23": "12933.8235654933",
  "2020-10-24": "13081.6725594906",
  "2020-10-25": "13008.4532577537",
  "2020-10-26": "13033.5242700816",
  "2020-10-27": "13721.2822248459",
  "2020-10-28": "13282.2603479223",
  "2020-10-29": "13467.7317828145",
  "2020-10-30": "13573.7105031536",
  "2020-10-31": "13891.2168331626",
  "2020-11-01": "13730.1973109361",
  "2020-11-02": "13633.6982168925",
  "2020-11-03": "13832.9384097683",
  "2020-11-04": "14163.9768155039",
  "2020-11-05": "15424.527676687",
  "2020-11-06": "15540.5965908122",
  "2020-11-07": "14783.9816785334",
  "2020-11-08": "15500.3342547421",
  "2020-11-09": "15283.7801387338",
  "2020-11-10": "15374.0443857602",
  "2020-11-25": "18748.5067"
}